export default {
  general: {
    login: 'Login',
    password: 'Passwort',
    email: 'E-Mail',
    firstName: 'Vorname',
    lastName: 'Nachname',
    name: 'Name',
    address: 'Adresse',
    zip: 'PLZ',
    city: 'Ort',
    phone: 'Telefonnummer',
    birthdate: 'Geburtsdatum',
    ok: 'Ok',
    cancel: 'Abbrechen',
    save: 'Speichern',
    swisspass: 'SwissPass',
    skicard: 'Skidata KeyCard',
    printAtHome: 'Print@Home',
    user: 'Benutzer',
    delete: 'löschen',
    next: 'Weiter',
    back: 'Zurück',
    select: 'Auswählen',
    skiticket: 'Skiticket',
    overview: 'Übersicht',
    I: 'Ich',
    date: 'Datum',
    here: 'hier',
    options: 'Optionen',
    option: 'Option',
    loadMore: 'Mehr anzeigen',
    ticket: 'Ticket',
    category: 'Kategorie',
    from: 'Von',
    rowsPerPage: 'Zeilen pro Seite',
    to: 'bis',
    loadingData: 'Daten werden geladen',
    close: 'Schliessen',
    price: 'Preis',
    country: 'Land',
    today: 'Heute',
    days: 'Tage',
    day: 'Tag',
    print: 'Drucken',
    apply: 'Anwenden',
    toCart: 'Zum Warenkorb',
  },
  layout: {
    register: 'Registrieren',
    booking: 'Online-Ticket',
    selectLanguage: 'Sprache',
    selectLanguageModalHeader: 'Sprache auswählen',
    userAccount: 'Profil',
    logout: 'Logout',
    menu: 'Menü',
    apply: 'Anmelden',
    helpAndFaq: 'Hilfe und FAQ',
    contact: 'Kontakt',
    customerManagement: 'Kasse',
    dashboard: 'Adminbereich',
    agb: 'AGB und Nutzungsbedingungen',
    myCards: 'Meine Datenträger',
  },
  registration: {
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    email: 'E-Mail *',
    password: 'Passwort *',
    passwordRepete: 'Passwort wiederholen *',
    acceptAgb:
      'Ich stimme den Datenschutzbestimmungen zu und akzeptiere die AGBs  *',
    acceptDataPrivacy: 'Ich stimme den Datenschutzbestimmungen zu *',
    youHaveToAcceptAgb:
      'Bitte stimmen Sie den AGB und Datenschutzbestimmungen zu',
    youHaveToAcceptDataPrivacy:
      'Bitte stimmen Sie den Datenschutzbestimmungen zu',
    registrationTitle: 'Benutzerkonto erstellen',
    register: 'Registrieren',
    eMailRequired: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    isNotEmail: 'Dies ist keine gültige E-Mail-Adresse',
    passwordWrong: 'Die Vorgaben sind nicht korrekt',
    passwordRequired: 'Bitte geben Sie ihr Password ein',
    passwordConstraints: 'Vorgaben Passwort',
    passwordIsNotUid:
      'Das Passwort darf nicht E-Mail, Vorname oder Nachname enthalten',
    passwordHasLetters:
      'Das Passwort muss Gross- und Kleinbuchstaben enthalten.',
    passwordHasCapitalLetter:
      'Das Passwort muss mindestens einen Grossbuchstaben enthalten.',
    passwordHasSpecialCharacter:
      'Das Passwort muss mindestens ein Sonderzeichen enthalten.',
    passwordHasNumber: 'Das Passwort muss mindestens eine Zahl enthalten.',
    passwordEqual: 'Die Passwörter müssen übereinstimmen.',
    passwordLength: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    alreadyAccount: 'Haben Sie bereits einen Account? Hier klicken.',
    firstNameRequired: 'Bitte geben Sie Ihren Vornamen ein',
    lastNameRequired: 'Bitte geben Sie Ihren Nachnamen ein',
    checkInput: 'überprüfen',
    street: 'Adresse',
    streetStar: 'Adresse *',
    zip: 'PLZ *',
    city: 'Ort',
    cityStar: 'Ort *',
    cityRequired: 'Bitte geben Sie den Wohnort ein',
    country: 'Land',
    zipRequired: 'Bitte geben Sie die PLZ ein',
    addressRequired: 'Bitte geben Sie Ihr Adresse an',
    phone: 'Telefonnummer',
    phoneStar: 'Telefonnummer *',
    phoneRequired: 'Bitte Telefonnummer eingeben.',
    companyRequired: 'Bitte Firma erfassen',
    companyStar: 'Firma *',
    company: 'Firma',
  },
  login: {
    loginHeadline: 'Login',
    checkMail: 'E-Mail prüfen',
    passwordRequired: 'Sie müssen ein Passwort eingeben',
    saveCookie: 'Eingeloggt bleiben',
    onlyOnPersonalComputer: 'Nur auf persönlichem Computer empfohlen',
    forgetPw: 'Passwort vergessen?',
    passwordSentExplanation:
      'Wir haben Ihnen soeben eine E-Mail mit einem neuen Passwort zugesendet. Prüfen Sie Ihr Mail-Postfach und loggen Sie sich mit den Angaben bequem bei uns ein.',
    passwordSentInfo:
      'Sie fragen sich, weshalb wir Ihnen ein neues Passwort zustellen? Einer unserer Mitarbeiter hat in der ' +
      'Vergangenheit in Ihrem Auftrag eine Reservation/Buchung entgegengenommen und in diesem Zuge einen Account erstellt. ' +
      'Damit möchten wir Ihnen grösstmöglichen Komfort bieten und Ihre Anmeldung beschleunigen. Mit dem Passwort, das wir Ihnen soeben zugestellt haben, ' +
      'können Sie sich nun in Ihrem Account anmelden.',
    acceptAgbsButton: 'AGBs akzeptieren',
    acceptAgbs: 'Bitte bestätigen Sie unsere AGBs',
    errorWhileDataTransfer:
      'Beim Übertragen Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.',
  },
  spinner: {
    pleaseWait: 'Einen Moment bitte',
    tryToLogin: 'Wir versuchen, Sie automatisch einzuloggen.',
  },
  notify: {
    errorDeleteCapacity: 'Die Kapazitäten konnten nicht gelöscht werden.',
    errorUpdateCapacity: 'Die Änderung konnte nicht gespeichert werden.',
    userSuccessfullyRegistered: 'Vielen Dank für Ihre Registrierung. ',
    registrationFailed:
      'Leider ist etwas schiefgelaufen. Versuchen Sie es später nochmals.',
    standardError:
      'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später nochmals,',
    passwordWasSent: 'Sie haben eine E-Mail mit Ihrem Passwort erhalten.',
    emailDoesNotExist:
      'Die E-Mail existiert nicht. Sie müssen sich zuerst registrieren.',
    loginSuccess: 'Erfolgreich eingeloggt!',
    loginError: 'Beim Login ist ein Fehler aufgetreten.',
    logoutSuccess: 'Erfolgreich ausgeloggt!',
    autologinFailed: 'Wir konnten Sie leider nicht automatisch einloggen',
    languageChangedSuccessfully:
      'Wir haben die neue Sprache in Ihrem Profil gespeichert.',
    languageCouldNotBeSaved:
      'Wir konnten Ihre neue Sprache leider nicht in Ihrem Profil speichern.',
    profileInfoSaved: 'Wir haben die Informationen gespeichert. Vielen Dank!',
    mailNotSaved: 'Wir konnten die E-Mail Adresse leider nicht speichern.',
    mailsHaveToBeEquals: 'Die E-Mails stimmen nicht überein.',
    passwordChangedSuccessfully: 'Das Passwort wurde erfolgreich geändert.',
    pwResetCodeSentToMail:
      'Wir haben Ihnen eine E-Mail mit einem Code geschickt. Kopieren Sie diesen in das Feld unten.',
    wrongCodeSent:
      'Sie haben einen falschen Code eingegeben. Kontrollieren Sie ihn nochmals genau.',
    passwordResetSuccessfull:
      'Sie haben das Passwort erfolgreich zurückgesetzt.',
    clickedDayHasToBeLinked: 'Sie können nur zusammenhängende Tage auswählen.',
    maxReservationTimeLimitReached:
      'Sie können leider nicht mehr Tage am Stück reservieren',
    dayIsInPast: 'Das Datum liegt ausserhalb der Saison',
    selectDay: 'Bitte wählen Sie einen Tag und ein Ticket aus',
    fullFillForm: 'Bitte füllen Sie alle benötigten Felder aus',
    voucherIsInvalid: 'Voucher ist ungültig:',
    maxDayLimitExeeded:
      'Sie können maximal {maxSelectedDays} Tage am Stück buchen.',
    loadingWeatherFailed: 'Wetterdaten konnten nicht geladen werden',
    updatingWeatherFailed: 'Vorhersage konnte nicht angepasst werden',
    errorWhileFetchingCapacities:
      'Die Kapazitäten konnten nicht geladen werden.',
    errorCreatingNewCapacity: 'Die Kapazität konnte nicht erstellt werden.',
  },
  profile: {
    personalInformation: 'Persönliche Angaben',
    birthday: 'Geburtstag *',
    changeMailModalHeader: 'E-Mail ändern',
    newMailFirst: 'Neue E-Mail *',
    newMailRepeat: 'Neue E-Mail wiederholen *',
    perfectSkiDay: 'Beschreiben Sie ihren perfekten Skitag',
    optionalDataHeaderText: 'Optionale Angaben',
    favoriteSkiRessort: 'Mein Lieblingsskigebiet',
    favoriteSkiMask: 'Meine Lieblingsskimarke',
    education: 'Ausbildung',
    profession: 'Beruf',
    changePassword: 'Passwort ändern',
    changePasswordModalTitle: 'Passwort ändern',
    myCards: 'Meine Datenträger',
    cardType: 'Typ',
    cardNumber: 'Nummer',
    deactivateProfile: 'Profil deaktivieren',
    reallyDeactivateProfile: 'Wollen Sie Ihr Profil wirklich deaktivieren?',
    reallyDeleteText:
      'Wenn Sie Ihr Profil deaktivieren, werden wir Ihre hinterlegte Mail-Adresse löschen. ' +
      '<b>Sie werden das Konto nicht mehr verwenden können. Ihr Konto wird deaktiviert!</b>',
    yourName: 'Ihr Name',
    doesNotMatchWithYourName: 'Die Eingabe entspricht nicht Ihrem Namen.',
    enterYourNameForSecurityReasons:
      'Tippen Sie zur Sicherheit Ihren Vornamen in das Feld.',
  },
  rule: {
    inputRequired: 'Die Eingabe ist verlangt',
    firstName: 'Bitte geben Sie den Vornamen ein',
    lastName: 'Bitte geben Sie den Nachnamen ein',
    birthdate: 'Bitte geben Sie das Geburtsdatum an',
    selectCard: 'Bitte wählen Sie eine Karte aus',
    selectUser: 'Person zuordnen',
    selectDataMedium: 'Bitte Speicherort wählen',
    addVoucher: 'Bitte geben Sie einen gültigen Voucher-Code ein',
  },
  resetPw: {
    resetPwButton: 'Passwort zurücksetzen',
    explanation:
      'Geben Sie die E-Mail-Adresse an, die mit Ihrem Account verbunden ist. Wir schicken Ihnen einen Code, mit dem Sie Ihr Passwort zurücksetzen können.',
    headline: 'Passwort zurücksetzen',
    codeRequired:
      'Wir haben Ihnen einen Code per Mail geschickt. Kopieren Sie ihn in dieses Feld.',
    resetCode: 'Code, den Sie per Mail erhalten haben, hier eingeben',
    newPw: 'Neues Passwort *',
    newPwRepeat: 'Neues Passwort wiederholen *',
    userNotFound: 'Diese E-Mail ist bei uns nicht registriert',
  },
  myProfiles: {
    newProfile: 'Nutzer hinzufügen',
    birthday: 'Geburtstag *',
    birthdayRequried: 'Bitte wählen Sie Ihren Geburtstag',
    profilesNotLoaded: 'Die Profile konnten nicht geladen werden',
    userDeleted: 'Wir haben den Benutzer gelöscht',
    userNotDeleted: 'Wir konnten den Benutzer leider nicht löschen',
    reallyDelete: 'Wollen Sie den Benutzer wirklich löschen?',
  },
  cardAdder: {
    addCard: '+',
    cardNumber: 'Kartennummer',
    cardNumberRequired: 'Bitte geben Sie die Kartennummer ein',
    waitingForCamera:
      'Wir laden die Kamera. Kurzen Moment bitte. Bitte überprüfen Sie Ihre Browser-Einstellungen, wenn ' +
      'die Kamera nicht innert ein paar Sekunden geladen werden kann.',
    zipRequired: 'Bitte geben Sie Ihre PLZ ein.',
    cardDescription: 'Geben Sie der Karte einen Namen',
    acceptSwisspassAgb: 'Bitte stimmen Sie den SwissPass-Bedingungen zu.',
    swisspassAgb: 'Ich stimme den SwissPass-Bedingungen zu',
    smartCard: 'Axess KeyCard',
    captureSmartCard: 'Axess KeyCard erfassen',
    smartCardInputExplanation:
      'Grundsätzlich können Sie jede beliebige KeyCard von Axess ' +
      '(auch von einem anderen Skigebiet) verwenden. Geben Sie dazu im Feld «Kartennummer» die Nummer ' +
      'von der Rückseite Ihrer KeyCard ein. Die Eingabe erfolgt <u>mit Bindestrich.</u>',
  },
  addNewProfile: {
    newProfileAddedSuccessfully: 'Neues Profil hinzugefügt',
    birthdayRequired: 'Bitte geben Sie das Geburtsdatum ein.',
    newCardModalTitle: 'Karte hinzufügen',
    cardAdded: 'Karte wurde hinzugefügt',
    invalidSkicardNumber: 'Die Kartennummer ist falsch.',
    invalidSwisspassNumber:
      'Die Kartennummer ist falsch. Geben Sie im Feld «Kartennummer» Ihre 11-stellige ' +
      'SwissPass-Nummer inklusive S aber ohne Bindestriche ein. Sie finden die Nummer auf der Rückseite ' +
      'Ihres SwissPasses.',
    cards: 'Karten',
    cardDelted: 'Wir haben die Karte gelöscht',
    userUpdated: 'Wir haben den User aktualisiert',
    mailAlreadyExists: 'Diese E-Mail existiert bereits für {user}',
    wrongBirthdayFormat: 'Bitte Geburtsdatum im Format TT.MM.JJJJ eingeben.',
    userLinkedToRegion:
      'Die Person wurde hinzugefügt. Bitte jetzt den Kunden via Suchfeld hinzufügen.',
  },
  booking: {
    selectDate: 'Datum wählen',
    selectPerson: 'Personen auswählen',
    timeLeft: 'Verbleibende Buchungszeit',
    cashPaymentFailed: 'Zahlung konnte nicht gespeichert werden!',
    cashPaymentSuccessful: 'Zahlung erfolgreich',
    noteCouldNotBeSaved: 'Bemerkung konnte nicht gespeichert werden.',
    noteSaved: 'Bemerkung wurde gespeichert.',
    unexpectedAmount:
      'ACHTUNG: Der einkassierte Betrag stimmt nicht mit dem Betrag der Preisberechnung überein! ' +
      'Bitte informieren Sie umgehend den Support von Pricenow mit folgenden Angaben: Buchungs-Id: {bookingId} / erwarteter Betrag: {expectedAmount}',
    bookingChanged: 'Änderungen an der Buchungen gespeichert.',
    bookingNotChanged: 'Änderungen konnten nicht gespeichert werden.',
  },
  dashboard: {
    pricing: 'Pricing',
    datanalytics: 'Data Analytics',
    customerManagement: 'Kundenverwaltung',
  },
  noAccess: {
    noAccess: 'Sie haben keine Berechtigung für diese Seite',
    goToLogin: 'Zum Login',
  },
  selectDate: {
    fromPrice: 'ab',
    selectDayInCalendar: 'Wählen Sie im Kalender einen Tag aus',
    addTicketHint: 'Fügen Sie ein Ticket hinzu',
    totalWithDiscount: 'Zu bezahlen',
    pricesFor: 'Preisanzeige für',
    who: 'Personen hinzufügen',
    infoHeader: 'Passende Daten wählen',
    infoText:
      'Wählen Sie die passenden Daten für Ihr Skivergnügen. Sie können 1 bis maximal 14 Tage auswählen. Sie können die Dauer in der Liste ändern.',
  },
  bookingOptions: {
    reclassification: 'Umbuchung',
    basic: 'Basic',
    flex: 'Flex',
    selectTarif: 'Wählen Sie den passenden Tarif',
    basicTarif: 'Basic Tarif',
    flexTarif: 'Flex Tarif',
    chooseYourExtras: 'Wählen Sie Ihre Extras',
    dateSelected: 'Daten gewählt',
    optionOnlyForFullDayAvailable: 'Option nur für Tageskarten verfügbar',
    addOption: 'Extra hinzufügen',
  },
  personalData: {
    newCustomer: 'Ich bin Neukunde',
    registerNow: 'Jetzt registrieren',
    alreadyCustomer: 'Ich bin bereits Kunde',
    furtherWithoutRegistration: 'Weiter ohne Account',
    whereToStoreTheTicket: 'Bitte Speicherort wählen',
    saveTicketHere: 'Hier soll mein Ticket gespeichert werden',
    whereToDeliver: 'Wohin sollen wir die Tickets liefern?',
    toWhomBelongsTicket: 'Wem soll das Ticket gehören?',
    addNewPerson: 'Person erfassen',
    addNewCard: 'Karte hinzufügen',
    cardBuyMsg:
      'Die KeyCard wird käuflich erworben. Sie kann beliebig oft wieder aufgeladen werden.',
    selectCard: 'Wähle eine Karte',
    newSwisspass: 'Neuen SwissPass erfassen',
    newKeyCard: 'Keine Keycard. Jetzt Erfassen.',
    tooYoung: 'Person ist zu jung für Ticket',
    tooOld: 'Person ist zu alt für Ticket',
    personAlreadyInUse: 'Person wurde bereits bei anderem Ticket gewählt.',
    advantage1: 'Ticket künftig schneller buchen',
    advantage2: 'Familie & Freunde einfach hinzufügen',
    advantage3: 'Exklusive Sonderangebote erhalten',
  },
  bookingOverview: {
    dayDiscounts: 'Mehrtagesrabatt',
    flexTarif: 'Option Flex',
    subtotal: 'Subtotal',
    addNewPerson: 'Weitere Person hinzufügen',
    vouchers: 'Online-Guthaben',
    familyDiscount: 'Familienrabatt',
    areYouFamily: 'Sind Sie eine Familie?',
    commingAsFamily: 'Bestätigen',
    familyDiscountAdvantages:
      'Als Familie können sie von attraktiven Ermässigungen profitieren. Bitte bestätigen Sie, ' +
      'dass die ausgewählten Kinder-Tickets für Kinder Ihrer Familie sind.',
    spotChecksPossible: 'Es können Stichproben durchgeführt werden.',
    bookingOverview: 'Buchungsübersicht',
  },
  success: {
    authtokenProblem:
      'Sie haben möglicherweise die Cookies deaktiviert. Bitte loggen Sie sich ein und lösen Sie in Ihrem Profil die Buchung erneut aus.',
    missingLiability:
      'Es gibt ein Problem. Offenbar ist Ihre Bank nicht vertrauenswürdig.',
    checkForPaymentStatus:
      'Wir prüfen im Hintergrund, ob die Zahlung erfolgreich war.',
    paymentErrorTryAgain: 'Klicke hier, um die Zahlung nochmals auszulösen',
    paymentSuccessfull: 'Vielen Dank für Ihre Buchung!',
    paymentSuccessfullSubheading: 'Wir freuen uns auf Sie.',
    paymentSuccessfullSubheadingChaeserrugg:
      'Wir wünschen Ihnen eine erholsame Zeit im Chäserrugg Gebiet.',
    unknowError: 'Ein Fehler ist aufgetreten',
    goToBookingOverview: 'Zur Buchungsübersicht',
    retryPayment: 'Nochmals versuchen',
    bookingTooOld: 'Die Buchung ist abgelaufen',
    goBack: 'Neue Buchung',
  },
  purchase: {
    voucherInput: 'Online-Guthaben-Code eingeben',
    voucherNotValidated: 'Dieser Voucher wurde noch nicht hinzugefügt',
    cashVoucher: 'Online-Guthaben einlösen',
    bookNow: 'Jetzt Buchen',
    validateVoucher: 'Voucher hinzufügen',
    voucherAlreadyAdded: 'Online-Guthaben-Code wurde bereits hinzugefügt',
    pricesTooOld: 'Ihre Buchungszeit ist leider abgelaufen.',
    notAllowed:
      'Sie haben nicht die Berechtigung, für die ausgewählten Benutzer, ein Ticket zu kaufen.',
    invalidTicketMode:
      'Ungültiger Ticket-Modus. Bitte wenden Sie sich an den Support.',
    selectedKeycardWrong:
      'Die ausgewählte Skikarte gehört nicht zum ausgewählten Benutzer',
    tryingToBookInThePast:
      'Sie versuchen ein Ticket in der Vergangenheit zu kaufen.',
    ticketCategoryInvalid:
      'Die Ticketkategorie ist ungültig. Bitte wenden Sie sich an den Support',
    invalidTicketType:
      'Ungültiger Ticket-Typ. Bitte wenden Sie sich an den Support',
    wrongOrderOfTickets:
      'Interner Fehler: Falsche Ticket-Reihenfolge. Bitte wenden Sie sich an den Support',
    wrongTimeZone:
      'Sie können in dieser Zeitzone keine Tickets buchen. Bitte wenden Sie sich an den Support.',
    invalidOption:
      'Ungültige Option ausgewählt. Bitte wenden Sie sich an den Support',
    amountFailed:
      'Bei der Berechnung des Preises ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support.',
    flexBasicCombination:
      'Bei den Flex/Basic-Optionen ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support.',
    newShadowUserNotCreated:
      'Der Benutzer konnte nicht hinzugefügt werden. Bitte wenden Sie sich an den Support.',
    newSkiCardNotCreated:
      'Die Skikarte konnte für den neuen Benutzer nicht hinzugefügt werden. Bitte kontaktieren Sie den Support.',
    goToMyBookings: 'Zur Buchungsübersicht',
    buyMore: 'Mehr Tickets kaufen',
    acceptAgs:
      'Bitte lesen und akzeptieren Sie die Datenschutzbestimmungen und die AGBs, um die Buchung abzuschliessen.',
    IAcceptAgb:
      'Ich habe die Datenschutzbestimmungen und AGBs gelesen und stimme ihnen zu.',
    accept: 'Zustimmen',
    addMissingUserDataModalHeader: 'Fast geschafft!',
    vaucherInput: 'Gutschein/Online-Guthaben einlösen',
    decline: 'Ablehnen',
    book: 'Buchen',
    voucherInfoText:
      'Wenn Sie einen Online-Guthaben-Code erhalten haben, können Sie diesen hier eingeben. Sie können ' +
      'auch all Ihre Online-Guthaben-Codes in Ihrem Profil (<span class="fa fa-user"></span>) finden.',
  },
  outOfTime: {
    runOutOfTime: 'Ihre Buchungszeit ist leider abgelaufen.',
    reloadData: 'Buchungsprozess neu starten',
  },
  dataTable: {
    noDataAvailable: 'Keine Daten vorhanden',
    noResultFound: 'Keine Ergebnisse',
    allRows: 'Alle',
  },
  dataFooter: {
    pageText: '{0}-{1} von {2}',
    itemsPerPageText: 'Elemente pro Seite:',
    itemsPerPageAll: 'Alle',
    itemsPerPageAllText: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
  },
  myBookings: {
    myBookings: 'Meine Buchungen',
    newBookings: 'Neue Buchungen',
    oldBookingsHeader: 'Alte Buchungen',
    reference: 'Buchungs-Nr.',
    persons: 'Personen',
    destination: 'Skigebiet',
    cancelBooking: 'stornieren',
    cancelBookingModalTitle:
      'Schade, dass Sie Ihren Skitag nicht antreten können.',
    cancelBookingInformationA:
      'Hier können Sie Ihre Buchung stornieren und in ein Online-Guthaben umwandeln.',
    cancelBookingInformationB:
      'Welche Tickets sollen storniert werden und in ein Online-Guthaben umgewandelt werden?',
    cancelButton: 'stornieren',
    areYouSure: 'Sind Sie sicher?',
    confirm: 'bestätigen',
    overviewTicketsToCancelText:
      'Folgendes Ticket wird storniert und in ein Online-Guthaben umgewandelt',
    ticketsSuccessfullyCanceled:
      'Die Tickets wurden storniert und in ein Online-Guthaben umgewandelt.',
    ticketsNotCanceled:
      'Die Tickets konnten wegen eines technischen Fehlers nicht storniert werden.',
    isFlex: 'Nicht stornierbar',
    isStorno: 'storniert',
    details: 'Buchungsdetails',
    noBookingFound:
      'Die Buchung ist entweder bereits abgelaufen oder existiert nicht',
    ticketNr: 'Ticket-Nr.',
    noOptions: 'Keine',
    dataMedium: 'Speichermedium',
    pdfIsGenerating:
      'PDF wird generiert. Klicken, um es nochmals zu versuchen.',
    downloadTicket: 'Ticket herunterladen',
    ticketNotPaid: 'Ticket wurde nicht bezahlt.',
    paymentDetails: 'Zahlungsdetails gesamte Buchung',
    services: 'Leistungen',
  },
  myVauchers: {
    myVauchers: 'Mein Online-Guthaben',
    vaucherCode: 'Online-Guthaben-Code',
    credit: 'Online-Guthaben',
    maxDate: 'Gültig bis',
    description:
      'Sie können Ihr Online-Guthaben für den Kauf neuer Angebote im Webshop nutzen.',
    cashVaucher: 'einlösen',
    noDataAvailable: 'Kein Online-Guthaben vorhanden',
  },
  cardsList: {
    addCard: 'SwissPass / KeyCard',
    noCardsAvailable: 'Keine Karten vorhanden',
    unknownCardType: 'Unbekannte Karte',
    description: 'Beschreibung',
  },
  overviewTicketOffice: {
    searchTicketCode: 'Ticketcode validieren',
    addSwisspass: 'SwissPass erfassen',
    addKeyCard: 'Keycard erfassen',
    checkMail: 'Wir prüfen die E-Mail',
    keyCardAdded: 'Keycard wurde erfasst.',
  },
  ticketOffice: {
    addSwisspass: 'SwissPass erfassen',
  },
  optionTable: {
    checkingAvailability: 'Wir prüfen die Verfügbarkeit.',
  },
  bookingManagement: {
    loadingCamera: 'Kamera lädt...',
    validate: 'validieren',
    storno: 'stornieren',
    serachByName: 'Nach Name suchen',
    scanTicketCode: 'Ticket scannen',
    ticketInvalidated: 'Das Ticket wurde erfolgreich validiert',
    ticketNotInvalidated: 'Das Ticket konnte nicht validiert werden',
    user: 'Angaben zur Person',
    pricePaid: 'Bezahlter Preis',
    days: 'Buchungszeit',
    validatedBy: 'Validiert durch',
    ticketStornoSuccessfull:
      'Das Ticket wurde erfolgreich in eine Gutschrift umgewandelt',
    reallyStorno: 'Wirklich stornieren?',
    ticketStornoExplanaition:
      'Das Ticket wird in einen Pricenow-Shop-Online-Guthaben umgewandelt.',
    ticketAlreadyValidated: 'Das Ticket wurde bereits validiert!',
    ticketAlreadyCancelled:
      'Das Ticket wurde bereits storniert und ist ungültig!',
    cancelledBy: 'Storniert durch',
    cancelledAt: 'Storniert am',
    ticketNotPaid: 'Das Ticket wurde nicht bezahlt und ist ungültig!',
    selectTicket: 'Ticket auswählen',
    ticketFromTo: 'Buchungszeit',
    ticketCode: 'Referenznummer',
    ticket: 'Ticket',
    stornoNotPossible: 'Nicht stornierbar! Nur auf Kulanz.',
    flexCanBeCancelled: 'Flex: Kann storniert werden',
    stornoConditions: 'Bedingungen',
    minChar: 'Geben Sie mindestens 3 Buchstaben ein, um zu suchen',
    falseAccessRights:
      'Sie verfügen nicht über die notwendigen Rechte. Bitte nehmen Sie Kontakt mit dem Support auf.',
    putTicketsOnKeyCard: 'Ticket auf Skicard laden',
    resetKeyCardUid: 'zurücksetzen',
    withoutDepot: 'Ohne Depot',
    withDepot: 'Mit Depot',
    ticketToCardAddedSuccessfully: 'Ticket erfolgreich auf Skicard geladen',
    ticketAlreadyOnCard: 'Das Ticket wurde bereits auf eine Skicard geladen!',
    skiCardNumberNotValid: 'Die Nummer der Skicard ist ungültig',
    noTicketsProvided:
      'Technischer Fehler: Keine Tickets, die gelesen werden können.',
    ticketOverview: 'Ticket-Übersicht',
    ticketDoesNotExistInDatabase:
      'Das Ticket existiert nicht in dieser Datenbank',
    skidata: 'Skidata',
    putOnKeycard: 'Ticket auf Keycard',
    externalTicketProvider: 'Status externes Ticketingsystem',
  },
  overviewPricing: {
    visitors: 'Besucher',
    visitorsForecast: 'Besucherprognose',
    pricesForecast: 'Preisentwicklung',
    discountsOverview: 'Zusammensetzung Rabatte',
    actualPrice: 'Aktueller Preis',
    discountSum: 'Rabatte',
    earlyDiscount: 'Frühbucherrabatt',
    phaseDiscount: 'Saisonphase',
    weekdayDiscount: 'Wochentag',
    weatherDiscount: 'Wetter',
    overrideModalHeader: 'Anpassungen für',
    currentPrice: 'Aktueller Preis',
    inputRequired: 'Sie müssen einen Preis eingeben.',
    maxPrice: 'Maximaler Preis',
    changingReason: 'Kommentar Veränderungsgrund',
    newParamsStored: 'Neue Parameter gespeichert',
    guests: 'Gäste',
    ticketPrice: 'Preis (CHF)', // not in use
    differentDiscounts: 'Rabatte (%)',
    noMoreFuture: 'Die Anzeige ist nicht möglich',
    reallySaveChanges:
      'Sind Sie sicher, dass die Änderungen gespeichert werden sollen?',
    weatherCanNotBeChanged:
      'Das Datum ist zu weit entfernt und kann daher nicht manuell angepasst werden.',
    commentRequired: 'Bitte geben Sie den Änderungsgrund an.',
    product: 'Produkt',
    price: 'Preis',
    bookings: 'Buchungsstände',
    noChartData: 'Keine Daten vorhanden',
    weekRange: 'Zeitraum',
    startDate: 'Startdatum',
    regions: 'Regionen',
    week: 'Woche',
    weeks: 'Wochen',
    quantity: 'Stückzahl',
    countSelectedDefinitions: 'Es sind {counter} Produkte ausgewählt',
    cannotShowAllEntriesInTables:
      'Es können nicht alle gewählten Produktdefintionen in der Grafik dargestellt werden.',
    postedPrices: 'Preise',
    targetPrices: 'Target Prices',
    overwrite: 'Preisübersteuerung',
    history: 'Preisverlauf',
    undefined: 'Undefiniert',
  },
  captureUsers: {
    insertMail: '1. E-Mail vom Kunde eingeben',
    captureSwisspass: '2. SwissPass erfassen',
    createNewUser: '3. Angaben ergänzen',
    unknownResponseStatus: 'Unbekannter Antwortcode',
    userAlreadyExists: 'Person bereits erfasst',
    userAlreadyExistsExplanation:
      'Alles bestens! Die Person ist bereits in unserem System erfasst. Sie können das Fenster schliessen.',
    checkSwisspass: 'SwissPass prüfen',
    swisspassCombinationWrong:
      'SwissPass-Nummer und Postleitzahl stimmen nicht überein oder sind falsch.',
    shwadowUserAlreadyExists:
      'Die Person ist bereits in unserem System erfasst, hat sich aber noch nie angemeldet. ' +
      'Deshalb haben wir ihr eine E-Mail mit den notwendigen Informationen zugesendet. Sie können das Fenster schliessen.',
    mailSent: 'E-Mail verschickt',
  },
  registrationForm: {
    userAlreadyExists: 'Ein Benutzer mit dieser E-Mail existiert bereits.',
    phoneNumberForQueries: 'Telefonnummer für Rückfragen',
    salutation: 'Anrede',
    salutationStar: 'Anrede *',
    selectSalutation: 'Bitte Anrede auswählen',
    followingDestination:
      'Sie haben sich in einer der folgenden Destinationen bereits angemeldet',
    useYourPassword:
      'Loggen Sie sich mit Ihrem Passwort ein. Falls Sie das Passwort vergessen haben, können Sie es zurücksetzen.',
  },
  SCountry: {
    country: 'Land',
    countryMandatory: 'Land *',
    countryIsMandatory: 'Bitte wählen Sie ihr Land aus',
  },
  missingUserData: {},
  bookingDetail: {
    showDetails: 'Details anzeigen',
    hideDetails: 'Details ausblenden',
    noOptions: 'Keine',
    cancellationNumbers: 'Sperrnummern',
    unpaidBookingCannotHaveAnAmount:
      'Ein unerwarteter Fehler ist aufgetreten: Unbezahlte Buchung darf nicht mit einem Betrag über 0 Franken storniert werden.',
    unpaidBookingToReleaseCapacities:
      'Diese Buchung ist unbezahlt. Mit der Stornierung werden mögliche Kapazitätsbeschränkungen wieder freigegeben.',
    voucherAmount: 'Online-Guthaben erstellen',
    voucherFor: 'Online-Guthaben für',
    stornoForZero:
      'Buchungen, welche auf einen Mitarbeitenden der Destination lauten, müssen mit 0 Franken storniert werden!',
    noVoucherWillBeCreated: 'Es wird kein Online-Guthaben erstellt.',
    editBookingEntries: 'Leistungen bearbeiten',
    closeEditBookingEntries: 'Bearbeitung abbrechen',
    editBuyer: 'KäuferIn bearbeiten',
    validGA: 'Gültiges GA',
    invalidGA: 'Kein gültiges GA',
    validHTA: 'Gültiges Halbtax',
    invalidHTA: 'Kein gültiges Halbtax',
  },
  loginForm: {
    noAccount: 'Noch keinen Account? Jetzt registrieren',
    loginNow: 'Jetzt anmelden',
    transferDataRequest: 'Dürfen wir Ihre Daten übernehmen?',
    tranferDataText:
      'Ihre Daten sind bei uns bereits hinterlegt. Dürfen wir diese für die Destination {destination} übernehmen?',
    transferDataTextII:
      'Mit Ihrer Zustimmung akzeptieren Sie gleichzeitig die AGBs der Destination {destination}. ' +
      'Die aktuellen AGBs finden Sie unten auf dieser Webseite verlinkt.',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    authenticationFailed:
      'Das Passwort oder die E-Mail ist falsch. Bitte prüfen Sie Ihre Eingabe und versuchen Sie es erneut.',
  },
  paymentHandler: {
    goToBooking: 'Zurück zur Startseite',
  },
  bookingTarifs: {
    fare: 'Tarif',
    basicDescription:
      'Mit dem <span class="font-weight-bold">Baisc Tarif</span> erwerben Sie ein Skiticket, welches nicht umgebucht oder storniert werden kann. ' +
      'Das Skiticket ist nur für das ausgewählte Datum gültig. <br><br>' +
      'Mit dem <span class="font-weight-bold">Flex-Tarif</span> erwerben Sie ein Skiticket, welches flexibel umgebucht werden kann. Sie können das Ticket bis ' +
      'um <span class="font-weight-bold">23:59</span> Uhr des Vortages stornieren. Bei einer Stornierung wird die gesamte Buchung storniert. ' +
      'Eine Stornierung einzelner Skitage ' +
      'eines Mehrtagestickets ist nicht möglich. Dabei wird Ihnen der ursprüngliche Buchungsbetrag in Form eines Online-Guthabens gutgeschrieben, ' +
      'welchen Sie bei Ihrer nächsten ' +
      'Online-Buchung einlösen können. <br><br>' +
      'Mit dem <span class="font-weight-bold">Wahltarif</span> (z.B. 3 aus 4 Tagen) erwerben Sie ein Ticket, ' +
      'welches Ihnen die Flexibilität gibt, in Ihrem gewählten Zeitraum einen beliebigen Tag auszusetzen, z.B. bei schlechtem Wetter.',
    moreInformation: 'Mehr Informationen finden Sie hier.',
  },
  bookingLogin: {
    futureAdvantages: 'Geniessen Sie in Zukunft tolle Vorteile',
  },
  v2: {
    OptionsCouldNotBeenLoaded: 'Die Optionen konnten nicht geladen werden',
    soldOut: 'ausverkauft',
    availableOptions: 'noch {availableOptions} Stk.',
  },
  v3: {
    pleaseConfirmMail: 'Bitte bestätigen Sie Ihre E-Mail-Adresse',
    confirm: 'Bestätigen',
    mailSuccessfullyConfirmed:
      'Vielen Dank! Ihre E-Mail-Adresse wurde erfolgreich bestätigt.',
    goToLogin: 'Zum Login',
    pleaseSetPw: 'Fast geschafft! Setzen Sie noch ein Passwort.',
    usedTicketCannotBeCancelled:
      'Tickets, die ab heute gültig sind, müssen zusätzlich im Ticketsystem storniert werden!',
  },

  v4: {
    amount: 'Betrag',
    unknownError:
      'Es ist ein unbekannter Fehler aufgetreten (483). Bitte kontaktieren Sie den Support.',
    apiWasNotAbleToCalculateThePrice:
      'Es gab einen Fehler beim Berechnen des Preises. Bitte kontaktieren Sie den Support.',
    triesToBookATicketForWrongAge:
      'Sie versuchen, ein Ticket auf einen Datenträger (z.B. Swisspass) zu buchen, welcher die Altersbedingungen nicht erfüllt.',
    ticketOrOptionCostsLessThanZero:
      'Sie versuchen, ein Ticket oder eine Option zu kaufen, die weniger oder gleich 0 Franken kostet. Bitte kontaktieren Sie den Support.',
    skiCardAlreadyInUse:
      'Die Karte wird bereits verwendet. Bitte wähle eine andere.',
    stornoAmount: 'Betrag',
    stornoReasonRequired: 'Bitte Stornierungsgrund angeben.',
    giveMeAStornoReason: 'Stornierungsgrund',
    stornoAmountRequired: 'Bitte zu stornierenden Betrag eingeben.',
    stornoHistory: 'Stornierungsverlauf',
    selfStorno: 'Benutzer selbst',
    cashDeskStorno: 'Kassenmitarbeitende/Administratoren',
    selectCancellationType: 'Stornierung durch',
    selectCancellationTypeRequired:
      'Bitte wählen Sie einen Stornierungstyp aus',
    cancellationDate: 'Storniert am',
    noVoucherHasBeenGenerated: 'Kein Online-Guthaben',
    voucherOriginalRatio: 'Online-Guthaben-Wert / bezahlter Ticket-Preis',
    filter: 'Filter',
    noNameFound: 'Kein Name gefunden',
    ticketUser: 'Ticket-Inhaber',
    alreadyUsed: 'Eingelöst',
    cancellationDetailModalHeader: 'Details Stornierung',
    cancellation: 'Stornierung',
    voucherValue: 'Online-Guthaben-Wert',
    paidOriginalTicketPrice: 'Bezahlter Originalpreis',
    ticketOwner: 'Tickets',
    voucherOwner: 'Online-Guthaben-Besitzer',
    voucherOwnerInfo:
      'Der Online-Guthaben-Besitzer kann vom Ticket-Besitzer abweichen, weil der Käufer eines Tickets nicht zwingend der Ticket-Besitzer ist.',
    noVoucherGeneratedInfo:
      'Es wurde kein Online-Guthaben erstellt. Möglicherweise wurde das Ticket mit dem Wert 0 CHF generiert.', // ohne Wert
    tooLateForCancellation:
      'Das Ticket kann nicht mehr storniert werden. Eine Stornierung ist nur bis um 23.59 Uhr am Vortag des ersten Skitages möglich.',
  },
  v5: {
    seeYouInAutomn: 'Wir sind ab Herbst wieder für Sie da.',
    goodPricesSoon:
      'Dann können Sie genau hier wieder Ihre Skitickets zu Vorzugspreisen buchen.',
    sommerTickets:
      'Tickets für die Sommerbahn erhalten Sie derzeit direkt am Kassenschalter.',
    goodSommerInTheMeanTime:
      'Wir freuen uns auf Ihren Besuch und wünschen Ihnen für die Zwischenzeit sonnige Sommertage in Bellwald.',
    startdate: 'Startdatum wählen',
    searchPlaceholder: 'Suchen',
    selectDate: 'Bitte wähle ein Datum aus.',
    selectDuration: 'Bitte wählen Sie die Anzahl Tage aus.',
    durationDropdown: 'Anzahl Tage',
    basketInProgress:
      'Sie müssen erst alle Produkte in Ihrem Warenkorb fertig stellen. Klicken Sie auf den "Weiter"-Button.',
    basketUpdateNotSuccessfull:
      'Der Warenkorb konnte leider nicht aktualisiert werden.',
    twoPossibilities:
      'Für die Erfassung der Swisspass-Nummer haben Sie zwei Möglichkeiten',
    scanQrCode:
      'Halten Sie den QR-Code (1) Ihres SwissPasses vor die Kamera Ihres Handys/PCs.',
    cameraCapturing: 'Erfassung per Kamera',
    manualCapturing: 'Manuelle Erfassung',
    captureSwisspassNumber:
      'Geben Sie im Feld «Kartennummer» Ihre 11-stellige SwissPass-Nummer inklusive S aber ohne Bindestriche ein. ' +
      'Sie finden die Nummer auf der Rückseite Ihres SwissPasses (2).',
    keyCardCatpuring: 'Keycard-Nummer erfassen',
    keyCardInputExplanation:
      'Grundsätzlich können Sie jede beliebige Keycard von SKIDATA (auch aus anderen Skigebieten) verwenden. ' +
      'Geben Sie dazu im Feld «Kartennummer» die 23-stellige Nummer von der Vorderseite Ihrer Keycard ein. Die Eingabe erfolgt ohne Bindestriche.',
    completeUserData:
      'Um die Buchung abzuschliessen, ergänzen Sie bitte die benötigten Angaben (*)',
    paymentAlreadyVerified: 'Die Buchung wurde bereits geprüft.',
    total: 'Total',
    pdf: 'PDF',
    downloadPdf: 'PDF herunterladen',
    noPdfAvailable: 'Diese Buchung beinhaltet keine PDF-Datei.',
    vouchers: 'Online-Guthaben',
    productsAlreadyInBasket: 'Produkte bereits im Warenkorb',
    basket: 'Warenkorb',
    navigationErrorNoBasketEntriesInState:
      'Fügen Sie mindestens ein aktuelles Produkt in den Warenkorb oder klicken Sie zurück.',
    continueShopping: 'Weiter einkaufen',
    currentBasketWillBeDeleted: 'Der Warenkorb wird gelöscht!',
    areYouSureDeletingBasket:
      'Wenn Sie sich während dem Einkauf ausloggen, wird Ihr Warenkorb gelöscht und der aktuelle Buchungsprozess zurückgesetzt. Möchten Sie fortfahren?',
    notAvailable: 'Aktuell sind keine Tickets verfügbar',
    dataMediaAmount:
      '<b>Sie haben folgende Möglichkeiten, Ihr Ticket aufzuladen:</b><br><br>',
    dataMediumSwisspass:
      '<b>SwissPass</b> <br>' +
      '<ul>' +
      '<li>' +
      'Erfassung per Kamera: Halten Sie den QR-Code Ihres SwissPasses vor die Kamera  Ihres Handys/PCs.' +
      '</li>' +
      '<li>' +
      'Manuelle Erfassung: Geben Sie im Feld «Kartennummer» Ihre 11-stellige SwissPass-Nummer <u>inklusive S aber ohne</u> Bindestriche ein.<br>' +
      'Sie finden die Nummer auf der Rückseite Ihres SwissPasses.' +
      '</li>' +
      '<li>' +
      'Ihr Ticket wird automatisch auf dem SwissPass gespeichert und Sie können ohne Anstehen am Kassenschalter direkt zum Drehkreuz.' +
      '</li>' +
      '</ul>',
    dataMediumSkidata:
      '<b>SKIDATA-Keycard</b> <br>' +
      '<ul>' +
      '<li>Grundsätzlich können Sie jede beliebige Keycard von SKIDATA (auch aus anderen Skigebieten) verwenden. Geben Sie dazu im Feld «Kartennummer» die 23-stellige ' +
      'Nummer von der Vorderseite Ihrer Keycard ein. Die Eingabe erfolgt ohne Bindestriche.' +
      '</li>' +
      '<li>Ihr Skiticket wird automatisch auf dieser Keycard gespeichert und Sie können ohne Anstehen am Kassenschalter direkt auf die Pisten starten. ' +
      'Damit Sie die Karte schnell einer Person zuordnen können, geben Sie ihr einen Namen z.B. Keycard_Michael.' +
      '</li>' +
      '</ul>',
    dataMediumPrintAtHome:
      '<b>Print@Home</b><br>' +
      '<ul><li>Nach Ihrer Bestellung erhalten Sie per E-Mail eine PDF, welche Sie entweder ausgedruckt oder auf dem ' +
      'Mobiltelefon direkt beim Durchgang scannen können. Ein Besuch am Kassenschalter ist nicht notwendig. ' +
      'Alle gebuchten Tickets finden Sie auch in Ihrer Buchungsübersicht.' +
      '</li></ul>',
    dataMediumPickup:
      '<b>Pick-up / Abholen vor Ort</b><br>' +
      '<ul><li>Nach Ihrer Bestellung erhalten Sie per E-Mail ein PDF, welches Sie ausdrucken und am Kassenschalter vorlegen müssen. ' +
      'Dort erhalten Sie eine KeyCard, welche Sie idealerweise für Ihre nächste Online-Buchung aufbewahren.' +
      '</li></ul>',
    dataMediumAxess:
      '<b>Axess KeyCard</b><br>' +
      '<ul><li>Grundsätzlich können Sie jede beliebige KeyCard von Axess (auch von einem anderen Skigebiet) verwenden. ' +
      'Geben Sie dazu im Feld «Kartennummer» die Nummer von der Rückseite Ihrer KeyCard ein. Die Eingabe ' +
      'erfolgt <u>mit Bindestrich</u>.' +
      '</li></ul>',
    dataMediumPrintAtHomeSchnaager:
      '<b>Print@Home</b><br>' +
      'Nach Ihrer Bestellung erhalten Sie per E-Mail eine PDF, welche Sie ausdrucken und ' +
      'dem Alpuschnaager-Fahrer vorzeigen müssen. Sie können das Pickup-Ticket auch auf Ihrem Smartphone vorzeigen.',
    onlyFewTicketsLeft: 'maximal verfügbare Tickets zu diesem Preis',
    voucherAlreadyUsedInOtherBooking:
      'Buchung ungültig. Sie haben den Online-Guthaben-Code bereits in einer anderen Buchung verwendet.',
    paymentForBookingNotFound:
      'Die Zahlung für die Buchung wurde nicht gefunden. Bitte wenden Sie sich an den Support.',
    paymentFailed:
      'Die Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut z.B. mit einer anderen Kreditkarte.',
    calculatingPrices: 'Preise werden geladen',
    depot: 'Depot',
    choosingPersonForTicket: 'Person für Leistung «{ticket}» auswählen',
    gotToBackend: 'Ins Backend',
  },
  v6: {
    showFilter: 'Filter einblenden',
    hideFilter: 'Filter ausblenden',
    noNewPrice:
      'Der neue Preis konnte nicht gesetzt werden, weil dieser Null war.',
    setNewPrice: 'Preis überschreiben?',
    newPrice: 'Neuer Preis (CHF)', // not in use
    OverwritePrice: 'Preis überschreiben',
    newPriceRequired: 'Bitte geben Sie einen neuen Preis ein.',
    confirmOverwritePrice:
      'Sind Sie sicher, dass der Ticket-Preis für den {date} mit {price} CHF überschrieben werden soll?',
    sure: 'Sind Sie sicher?',
    minimalPrice: 'Minimalpreis',
    correctedDate:
      'Ihre Reservation hat länger gedauert, als unsere Saison dauert. Deshalb haben wir Ihre Datumswahl automatisch auf den letzt möglichen Tag angepasst.',
    addCard: 'Swisspass / Keycard hinzufügen',
    addNoCard: 'Keine Karte hinzufügen',
    includingCardFees: 'inkl. {fee} Depot',
    allBookingEntriesCancelled: 'Tickets storniert - Kein PDF',
    ticketCancelled: 'Ticket wurde storniert',
    overwirteAllPrices: 'Preise verändern',
    priceSuccessfullyOverwritten: 'Der Preis wurde erfolgreich überschrieben.',
    overwrittenPrice: 'Überschrieben',
    resetPrice: 'Preis zurücksetzen',
    youOverwriteTheFollowingTicket: 'Sie überschreiben folgendes Produkt',
    reset: 'zurücksetzen',
    dateRequired: 'Kein Datum ausgewählt',
    priceSuccessfullyReset: 'Preis erfolgreich zurückgesetzt.',
    ownForecast: 'Eigene Prognose',
    lastUpdated: 'Zuletzt aktualisiert am',
    resetOverwrittenPrice:
      'Möchten Sie den manuell überschriebenen Preis wieder auf den automatisch berechneten Preis zurücksetzen?',
    base: 'basis',
  },
  discounts: {
    family: 'Familienrabatt',
  },
  moduleNames: {
    skiTicket: 'Skitickets',
    skiTicketBellwald: 'Skitickets',
    skiTicketVals: 'Skitickets',
    sleddingTicket: 'Schlittel-Ticket',
    trainRide: 'Bahnfahrt',
    trainNiesen: 'Bahnbillette kaufen',
    tableReservationNiesen: 'Tisch Mittagessen',
    hotelNiesen: 'Übernachtung',
    trainReservationNiesen: 'Bahnfahrt reservieren',
    seasonAbosBellwald: 'Saison-Abo',
    singleRideBellwald: 'Einzelfahrt',
    skiTicketChaeserrugg: 'Skitickets',
    singleRideChaeserrugg: 'Einzelfahrt',
    seasonAbosChaeserrugg: 'Abos',
    hikingChaeserrugg: 'Wandertickets',
    skiMoosalpregion: 'Skitickets',
    seasonAbosMoosalpregion: 'Abos & Punktekarten',
    singleRideMoosalpregion: 'Einzelfahrten',
    sledgeChaeserrugg: 'Schlitteltickets',
    bikeparkBellwald: 'Bikepark',
  },
  routingTitles: {
    overviewPricing: 'Übersicht',
    pricingDetails: 'Pricing',
    pricingSettings: 'Einstellungen',
    pricingWeather: 'Wetter',
    pricingAnalytics: 'Analytics',
    profile: 'Mein Profil',
    myBookings: 'Meine Buchungen',
    myProfiles: 'Nutzer',
    myVouchers: 'Online-Guthaben',
    bookingOverview: 'Buchungen',
    extraRide: 'Bahn',
    stornoHistory: 'Stornierungen',
    pricingTable: 'Preisanzeige',
    capacity: 'Kapazitäten',
    products: 'Produkte',
    events: 'Events',
    cashDesk: 'Kasse',
    reports: 'Reports',
    settings: 'Einstellungen',
  },
  calendar: {
    days: {
      mo: 'Mo',
      tu: 'Di',
      we: 'Mi',
      th: 'Do',
      fr: 'Fr',
      sa: 'Sa',
      so: 'So',
    },
    soldOut: 'belegt',
    productNotAvailableOnDate: 'Produkt an diesem Datum nicht verfügbar',
    notAvailable: 'Nicht verfügbar',
  },
  weather: {
    weatherIn: 'Wetterprognose',
    edit: 'Ändern',
    title: 'Wetter Auswählen',
    changeForecast: 'Anpassen',
    changeWeatherConfirmation: 'Vorhersage Anpassen',
    ok: 'Ok',
    nok: 'Abbrechen',
    acceptChanges: 'Wollen Sie die folgende Änderung annehmen?',
  },
  pricingDetails: {
    percentage: '%',
    weekdayChartLabel: '% Preisaufschlag',
    weekdayChartTitle: 'Preisaufschlag %',
    valdemChartYLabel: 'Preisaufschlag chf',
    dates: 'Daten',
    filterChoice: 'Filter Optionen',
    days: 'Wochentag',
    weekdays: 'Wochentage',
    seasonPhases: 'Saisonphase und Feiertag',
    priceCombo: 'Gesamtpreis (CHF)', // not in use
    totalPrice: 'Gesamtpreis',
    valDem: 'Value & Demand',
    value: 'Value',
    demand: 'Demand',
    dailyBaseRate: 'Daily Base Rate',
    multiDayDiscount: 'Multi-Day Discount - Product Target Price',
    maximumEarlyBooking: 'Current Early Booking Discount',
    cashDeskPrice: 'Cash Desk Price',
  },
  productSelector: {
    noProductsAccess: 'Keine Produkte',
    loadingProducts: 'Lade Produkte...',
  },
  weekdays: {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
  },
  footer: {
    links: 'Links',
    acceptedPayments: 'Akzeptierte Zahlungsmittel',
    contact: 'Kontakt',
    poweredBy: 'powered by',
  },
  apiPage: {
    notFound: 'Fehler',
    notFoundDesc: 'Seite konnte nicht gefunden werden',
  },
  attributes: {
    region: 'Region',
    age: 'Personentypen',
    duration: 'Zeitspanne',
    flex: 'Leistungsart',
    performanceDiff: 'Leistungsdifferenzierung',
    room: 'Raum',
    train: 'Bahnfahrt',
    adults: 'Erwachsene',
    children: 'Kinder',
    route: 'Fahrt',
    from: 'Von',
    to: 'Nach',
    swisspass: 'Ermässigung',
    time: 'Zeit',
    personAmount: 'Anzahl Personen',
    trainAdults: 'Bahnfahrten Erwachsene',
    trainChildren: 'Bahnfahrten Kinder',
    meal: 'Essen',
    tarif: 'Tarif',
    voucherType: 'Gutschein-Typ',
    warningTexts: {
      gaHalbtax: {
        niesen:
          'Sämtliche Vergünstigungen (GA oder Halbtax) werden am Ende der Buchung vorgenommen.',
      },
    },
  },
  performanceDiffAdvantages: {
    ski: 'Skiticket',
    flexibility: 'Flexibilität',
    cancellation: 'Umbuchung',
  },
  performanceDifferentiation: {
    outOfDays: '{durationDays} aus {durationDaysPlus} Tagen',
  },
  emergencyDown: {
    text:
      'Bitte entschuldigen Sie die Unterbrechung. Wir machen gerade ein Update und sind in Kürze wieder für Sie da.',
  },
  extraRides: {
    extraRides: 'Bahn',
    fromDate: 'vom',
    toDate: 'bis',
    name: 'Ride',
    date: 'Datum',
    ascent: 'Bergfahrt',
    ascentTime: 'Zeit der Bergfahrt',
    descent: 'Talfahrt',
    descentTime: 'Zeit der Talfahrt',
    addedBy: 'Erstellt von',
    updatedAt: 'Erstellt am',
    comment: 'Bemerkung',
    edit: 'Bearbeiten',
    noDataAvailable: 'Keine Bahnfahrt eingetragen',
    newExtraRide: 'Bahnfahrt erfassen',
    editExtraRide: 'Bahnfahrt bearbeiten',
    applyExtraRide: 'Bahnfahrt speichern',
    applyChanges: 'Änderungen speichern',
    deleteExtraRide: 'Bahnfahrt löschen',
    confirmDeletion: 'Wollen Sie diese Bahnfahrt wirklich löschen?',
    cancelEditing: 'Abbrechen',
    newExtraRideSuccessfull: 'Neue Bahnfahrt wurde eingetragen',
    deletionSuccessfull: 'Bahnfahrt wurde gelöscht',
    editSuccessfull: 'Änderungen wurden übernommen',
    updateNotSuccessfull: 'Bahnfahrten konnten nicht geladen werden',
    editNotSuccessfull: 'Ausgewählte Bahnfahrt konnte nicht geladen werden',
    deletionNotSuccessfull: 'Bahnfahrt konnte nicht gelöscht werden',
    descDateError: 'Talfahrt kann nicht vor der Bergfahrt liegen',
    ascentDateNotSet: 'Bitte ein Datum für die Bergfahrt auswählen',
    ascentTimeNotSet: 'Bitte eine Zeit für die Bergfahrt auswählen',
    descentDateNotSet: 'Bitte ein Datum für die Talfahrt auswählen',
    descentTimeNotSet: 'Bitte eine Zeit für die Talfahrt auswählen',
  },
  shopBackendBookingOverview: {
    all: 'Alle',
    aggregated: 'Aggregiert',
    byCustomer: 'Nach Kunde',
    date: 'Datum',
    product: 'Produkt',
    personCount: 'Anzahl Personen',
    customer: 'Kunde',
    time: 'Zeit',
    bookingState: 'Buchungsstatus',
    remark: 'Bemerkung',
    customerSearch: 'Kundensuche',
    searchDefaultText: 'Suche nach Vorname, Nachname, Ort',
    tooManyWords: 'Nicht mehr als vier Wörter erlaubt',
    noSearchResult: 'Kein Suchresultat bisher',
    ticketCount: 'Tickets in dieser Buchung',
    validity: 'Gültigkeit',
    bookingsOfTheUser: 'Buchungen des Benutzers',
    calendar: 'Kalender',
  },
  shopBackendBookingDetail: {
    buyer: 'KäuferIn',
    missingId: 'Diese Seite existiert nicht! Keine Buchungs Id verfügbar',
    remark: 'Bemerkung',
    bookingState: 'Buchungsstatus',
    paymentDetails: 'Zahlungsdetails',
    name: 'Name',
    ticket: 'Ticket',
    price: 'Preis',
    save: 'Speichern',
    cancelMarkedTickets: 'Markierte Tickets stornieren',
    receivedMoney: 'Betrag einkassieren',
    printAllTickets: 'Tickets',
    paymentState: 'Zahlungsstatus',
    cancelTicket: 'Stornieren',
    abort: 'Abbrechen',
    cancellationAgreeText:
      'Wollen Sie die ausgewählten Tickets wirklich stornieren?',
    tickets: 'Tickets dieser Buchung',
    bookingStateWaitingList: 'Warteliste',
    bookingStateProvisionally: 'Provisorisch',
    bookingStateManualConfirmed: 'Bestätigt (via Mitarbeiter)',
    bookingStateAutoConfirmed: 'Bestätigt (via Shop)',
    bookingStateDefinitive: 'Bestätigt',
    paid: 'Bezahlt',
    notPaid: 'Nicht bezahlt',
    cancellationFaildForUnknownReason:
      'Die Stornierung ist aus einem unbekannten Grund fehlgeschlagen.',
    cancellationWasSuccessful: 'Die Stornierung war erfolgreich',
    validFrom: 'Gültig ab',
    skidataLockNumber: 'Sperrnummer',
    dataMedium: 'Datenträger',
    doNotForget: 'Nicht vergessen',
    cancellationGenerallyOk: 'Mögliches Online-Guthaben wurde erstellt.',
    thirdPartySystemCancellationFailed:
      'Einige Tickets konnten wir in einem Drittsystem nicht automatisch stornieren. ' +
      'Bei Skidata können Sie es mit der Reservationsnummer oder der Sperrnummer versuchen.',
    system: 'System',
    ticketsUnCancelableAsNotPaid:
      'Tickets können nicht storniert werden, weil die Buchung unbezahlt ist.',
    fromCity: 'aus',
    noRemark: 'Keine Bemerkung',
  },
  shopBackendBookingComplete: {
    day: 'Tag',
    fourDay: '4 Tage',
    week: 'Woche',
    month: 'Monat',
    timePeriod: 'Abfrageperiode',
    product: 'Produkt',
    productDefinition: 'Details',
    customer: 'Kunde',
    time: 'Zeit',
    bookingState: 'Buchungsstatus',
    remark: 'Bemerkung',
    extraTrip: 'Extrafahrt',
    addBooking: 'Buchung erfassen',
    xlsx: 'Liste Exportieren',
    peopleCount: 'Anzahl Personen',
    capacity: 'Kapazität',
    today: 'Heute',
    chooseDateRange: 'Abfrageperiode',
    dateRangeDescription:
      'Wählen Sie ein einzelnes Datum oder ein Start- sowie Enddatum',
    expand: 'Ausklappen',
    aggregatedBookings: 'Aggregierte-Buchungen',
    bookingDate: 'Buchungsdatum',
    paymentTime: 'Zahlungszeit',
    mail: 'E-mail',
  },
  skidata: {
    unknownState: 'Unbekannter Status',
    ok: 'Status: ok',
    cancellationSuccessfull: 'Erfolgreich storniert',
    unpaidNotInSkidata:
      'Unbezahlt, nicht in externes Ticketsystem geschrieben.',
    failedToCancelButInSkidata:
      'Stornierung in externem Ticketsystem fehlgeschlagen.',
    failedToWriteToSkidata: 'Nicht in externes Ticketsystem geschrieben.',
    state: 'Status',
    pickupCode: 'Barcode Ticket',
    noBarcode: 'Dieses Ticket hat keinen Barcode.',
    orderId: 'Reservationsnummer',
    keycardHasToStartWith01: 'Die Nummer muss mit 01 beginnen.',
    invalidCard: 'Ungültige Kartennummer.',
  },
  pricingTable: {
    askAtTheCashDesk: 'Am Schalter',
  },
  infoText: {
    vals: {
      ageRestrictions:
        'Kinder und Jugendliche mit Jahrgang 2004 oder jünger erhalten im Tourismusbüro Visit Vals eine ' +
        'personalisierte Saison-Freikarte. Mit dieser kann die ganze Saison das Drehkreuz passiert werden. ' +
        'An der Talstation der Bergbahn sind beim Gästebetreuer Kinder-Tages-Freikarten erhältlich.',
    },
  },
  shortCutTrainRide: {
    departure: 'Abfahrtsort wählen',
    destination: 'Zielort wählen',
    selectDeparture: 'Bitte Abfahrtsort wählen',
    selectDestination: 'Bitte Zielort wählen',
    selectRoute: 'Bitte treffen Sie Ihre Auswahl',
    hikingHint: '3 Stationen fahren, 1 Station wandern.',
    selectDate: 'Wählen Sie Ihr Datum',
  },
  shortCutTrainReservation: {
    infoBox:
      'Bahnreservationen sind nur bis 6:00 Uhr am Gültigkeitstag möglich. Sie können die ' +
      'Bahn aber auch ohne Reservation benützen. Ohne Reservation kann es an Spitzentagen zu Wartezeiten kommen.',
    chooseDate: 'Datum wählen',
  },
  shortCutTableReservation: {
    time: 'Zeit wählen',
    selectTime: 'Bitte wählen Sie eine Zeit aus',
    selectDate: 'Wählen Sie Ihr Datum',
  },
  selectMedium: {
    reduction: 'Ermässigung wählen',
    selectReduction: 'Besitzen Sie ein GA oder ein Halbtax?',
    selectTarifReduction:
      'Sind Sie einheimisch und besitzen einen entsprechenden Ausweis?',
    isNotASwisspass: 'Die gewählte Karte ist kein Swisspass!',
    swisspassDataNotUpdated: 'Swisspass konnte nicht überprüft werden.',
    swisspassHasNoGaOrHalfFare:
      'Ihr Swisspass hat kein gültiges GA oder Halbtax.',
    swisspassHasNoGA: 'Ihr Swisspass hat kein gültiges GA',
    swisspassHasNoHalfFare: 'Ihr Swisspass hat kein gültiges Halbtax',
    productForPerson: '{product} für {person}',
    completeBirthdate: 'Bitte ergänzen Sie das Geburtsdatum',
    preparingBasket: 'Ihr Warenkorb wird vorbereitet. Es geht gleich weiter.',
    customBellwaldLocalNotification:
      'Der Einheimischen-Tarif wird nur gegen Vorlage des offiziellen blauen Ausweises ' +
      '(oder einer Wohnsitzbestätigung) gewährt. Er muss nach dem 1. September des laufenden Jahres ausgestellt sein.',
    customChaeserruggLocalNotification:
      'Einheimische der Gemeinde Wildhaus – Alt St. Johann profitieren von einem ' +
      'Spezialtarif. Hiermit bestätigen Sie, dass Sie im Besitz eines gültigen Einheimischen-Ausweis der Gemeinde ' +
      'Wildhaus - Alt St. Johann sind und diesen bei Aufforderung vorweisen können.',
    customMoosalpregionLocalNotification:
      'Hiermit bestätigen Sie, dass Sie Ihren Wohnsitz im Kanton Wallis haben ' +
      'und im Fall einer Stichprobe dies anhand der Wohnsitzbestätigung belegen können.',
    customMoosalpregionGuestNotification:
      'Ich bestätige, dass ich im Besitz einer gültigen Gästekarte bin und ' +
      'diese jederzeit vorweisen kann. Stichproben können durchgeführt werden.',
    nonRefundable: 'Kartengebühr',
  },
  productsOverview: {
    editProducts: 'Produkte bearbeiten',
    edit: 'bearbeiten',
  },
  singleProductView: {
    editProduct: 'Produkt bearbeiten',
    vat: 'Mehrwertsteuern',
    capacity: 'Kapazitäten',
    editCapacity: 'Kapazitäten bearbeiten',
    capacityCalendar: 'Übersicht Kapazitäten',
    productImage: 'Produktbild',
    selectAProductImage: 'Wählen Sie ein Bild aus',
    maxImageSize: 'Maximalgrösse 1MB',
    uploadingFailed: 'Hochladen fehlgeschlagen',
    uploadingImage: 'Lade Bild hoch ...',
    imageDescription:
      'Empfohlenes Seitenverhältnis von 3:2. Die erlaubten Bildformate sind .jp(e)g und .png',
    simpleProductImage: 'Einfaches Bild',
    productDefImage: 'Mehrere Bilder',
    chooseProdDef: 'Wähle die Produkteigenschaft',
    productPresentation: 'Produkt präsentieren',
    productOverall: 'Produkt generell',
    productCharacteristics: 'Produkt-Eigenschaften',
    bookableDates: 'Produktverfügbarkeit',
    activeAfterNextPriceCalculation:
      'Hinweis: Die Einstellungen werden erst mit der nächsten Preisberechnung aktiv.',
    activate: 'Produkt publizieren',
    deactivate: 'Produkt deaktivieren',
    productIsDeactivated:
      'Das Produkt ist zurzeit inaktiv und somit nicht im Shop verfügbar',
    errorUpdatingActive: 'Fehler beim Aktualisieren des Status',
    additionalProductHasNoCapacities:
      'Vergleichsprodukt hat keine Kapazitäten festgelegt.',
  },
  productCapacity: {
    mapCapacityOnAttributes: 'Produkt-Eigenschaft',
    mapCapacityOnProduct: 'Produkt',
    capacityAmount: 'Kapazität',
    addCapacityAmount: 'Tragen Sie die Kapazität ein',
    capacityForProduct: 'Maximale tägliche Kapazität für das Produkt {product}',
    deleteAllCapacities: 'Kapazitäten zurücksetzen',
    reallyDelete: 'Wirklich löschen?',
    allCapacitiesWillBeDeleted:
      'Alle Kapazitäten dieses Produktes werden gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden!',
    editCapacity: 'Kapazität bearbeiten',
    capacityUpdatedSuccessfully: 'Änderung gespeichert.',
    capacityDeletedSuccessfully: 'Kapazitäten gelöscht.',
    capacityCreatedSuccessfully: 'Kapazität erstellt',
    capacitySpecification: 'Produkt-Eigenschaft',
    selectCapacitySpecification: 'Wählen Sie eine Produkt-Eigenschaft',
    attributeValue: 'Wert',
    selectAttributeValue: 'Bitte wählen Sie einen Wert aus',
    capacityForAttribute: 'Maximale Kapazität für «{attributeValue}»',
    capacityAttributeWrong:
      'Die Kapazitätseinstellungen stimmen nicht mit den Werten der Pricing-Engine überein. ' +
      'Dies führt zu falschen Angaben in der gesamten Applikation.',
  },
  capacityCalendar: {
    overrideCapacity:
      'Maximale Kapazität für {attributeOrProduct} überschreiben.',
    selectOverrideCapacity: 'Kapazität ändern',
    selectEditEvent: 'Event bearbeiten',
    startDateRequiredSmaller: 'Das Startdatum muss vor dem Enddatum liegen!',
    override: 'Überschreiben',
    whatDoYouWantToDo: 'Was möchten Sie tun?',
    showCapacitySibling: 'Vergleichsprodukt einblenden',
    disableCapacitySibling: 'Produkt ausblenden',
    showRuleBased: 'Weitere Optionen anzeigen',
    hideRuleBased: 'Weniger anzeigen',
    newCapacity: 'Neue maximale Kapazität für die Auswahl',
    showAll: 'Alle anzeigen',
  },
  valueCapacity: {
    updateCapacity: 'Kapazität überschreiben',
    capacityUpdated: 'Kapazität überschrieben',
    capacityNotUpdated: 'Kapazität konnte nicht überschrieben werden.',
  },
  personAdder: {
    checkForAvailability: 'Wir prüfen die Verfügbarkeit.',
    availableTickets:
      'Ausverkauft | Noch 1 verfügbar | Noch {stockLeft} verfügbar',
    soldOut: 'Ausverkauft. Leider sind keine weiteren Tickets verfügbar.',
    ticketsSoldOutRemoved:
      'Leider ist das gewünschte Ticket bereits ausverkauft.',
    noFreeTable:
      'Um diese Zeit ist kein Tisch mehr verfügbar, wählen Sie eine andere Zeit.',
    selectAttribute: '{attribute} wählen',
    basketConditions: {
      min: 'Fügen Sie {attributeTitle} mindestens {count}x in den Warenkorb.',
      max: 'Fügen Sie {attributeTitle} maximal {count}x in den Warenkorb',
    },
  },
  shopComment: {
    textFieldLabel: {
      trainRideNiesen: 'Bemerkungen oder Wünsche an das Team der Niesenbahn AG',
    },
    adminNote: {
      trainRideNiesen: 'Platzwünsche können nicht garantiert werden.',
      tableReservation:
        'Bergfahrt dauert 30 Minuten, Platzwünsche können nicht garantiert werden.',
    },
    maxCharacter: 'Es sind maximal 240 Zeichen erlaubt.',
  },
  product: {
    bookingOnlyTill:
      'Buchung nicht möglich. Die Reservation muss bis spätestens am {bookingTill} Uhr erfolgen. Bitte wählen Sie ein späteres Datum.',
    callForBooking:
      'Buchung online nur bis {bookingTill} Uhr möglich. Für kurzfristige Buchungen melden Sie sich bitte unter {phoneNumber}.',
    eventsCouldNotBeLoaded: 'Events konnten nicht geladen werden.',
    loadingEvents: 'Events werden geladen',
    failedLoadingAdditionAttr: 'Attribute konnten nicht geladen werden',
    loadingValidityDates: 'Abrufen der Produktverfügbarkeit',
    updatingValidityDates: 'Anpassen der Produktverfügbarkeit',
    errorUpdatingValidityDates:
      'Update der Produktverfügbarkeit fehlgeschlagen',
    updatedValidityDates: 'Produktverfügbarkeit erfolgreich angepasst',
    sureToUpdate:
      'Sind Sie sicher, dass Sie die Produktverfügbarkeit anpassen wollen?',
    noBookingDateLeft: 'Das Produkt ist bis Ende Saison ausverkauft!',
    pricesCouldNotBeLoaded: 'Preise konnten nicht geladen werden.',
  },
  shortCutHotel: {
    chooseArrivalDate: 'Ankunftsdatum wählen',
  },
  stepperModal: {
    niesen: {
      seatReservationModalText:
        'Die Plätze in der Bahn sind limitiert. ' +
        'Mit einer Bahnfahrt-Reservation garantieren wir Ihnen einen Platz in der Bahn zur ausgewählten Zeit.\n' +
        '<br>Wenn Sie eine Bahnfahrt-Reservation gemacht haben, bitten wir Sie, sich spätestens ' +
        '<b>10 Minuten</b> vor der reservierten Bahnfahrt beim <b>Gruppeneingang</b> ' +
        '(beachte die Signalisation vor Ort) mit Ihrer <b>Reservation</b> (Print oder auf dem Handy) einzufinden.\n' +
        '<br>Ansonsten kann Ihre Bahnfahrt-Reservation nicht garantiert werden. \n' +
        '<br>Bitte beachten Sie, dass Sie für die Fahrt mit der Bahn zusätzlich zur Reservation ein <b>reguläres Bahnbillet</b> benötigen.\n',
    },
  },
  hotelRoomSelector: {
    moreInformation: 'Mehr Informationen',
    addToBasket: 'In den Warenkorb',
    roomAddedSuccessfully: 'Zimmer hinzugefügt.',
    moreDetails: 'Mehr Details',
  },
  singleEventView: {
    editEvent: 'Event bearbeiten',
    createEvent: 'Event erstellen',
    eventTemplate: 'Event-Vorlage',
    selectEventTemplate: 'Bitte wählen Sie eine Event-Vorlage.',
    eventDate: 'Event-Datum',
    selectEventDate: 'Bitte wählen Sie ein Event-Datum',
    eventTitle: 'Titel',
    eventLead: 'Kurzbeschreibung',
    eventDescription: 'Ausführliche Beschreibung',
    eventTitleRequired: 'Bitte geben Sie einen Titel ein.',
    eventLeadRequired: 'Bitte geben Sie eine Kurz-Beschreibung ein.',
    eventDescriptionRequired: 'Bitte beschreiben Sie das Produkt.',
    removeEventFromShop: 'Event deaktivieren',
    publishEvent: 'Event publizieren',
    eventIsPublished: 'Dieser Event ist im Shop publiziert.',
    eventIsUnpublished:
      'Dieser Event ist unpubliziert und nicht sichtbar im Shop.',
    eventStartTime: 'Start des Events',
    eventEndTime: 'Ende des Events',
    eventStartMandatory: 'Bitte Startzeit eingeben.',
    eventEndMandatory: 'Bitte Endzeit eingeben.',
    timeIncomplete: 'Zeit bitte im Format hh:mm erfassen.',
    editDescription: 'Event-Beschreibung',
    editPricing: 'Pricing',
    selectEventImage: 'Wählen Sie ein Eventbild aus',
    eventImage: 'Event-Bild',
    presentEvent: 'Event beschreiben',
    eventData: 'Event-Daten',
    iconText: 'Icon Text',
    iconTextRequired: 'Bitte geben Sie einen Icon-Text ein.',
    iconRequired: 'Bitte Icon auswählen',
    iconsTitle: 'Icons',
    noIcons: 'Keine Icons in Verwendung',
    eventNotDeleted:
      'Event konnte nicht gelöscht werden, da bereits darauf gebucht wurde.',
    deleteEvent: 'Event löschen',
    reallyDeleteHeader: 'Event wirklich löschen?',
    reallyDeleteText:
      'Diese Löschung kann nicht rückgängig gemacht werden. Der Event kann nicht wiederhergestellt werden.',
    overrideTime: 'Zeit ändern',
    reallyOverrideTime: 'Zeit wirklich ändern?',
    explainTimeChange:
      'Gäste, die den Event bereits gebucht haben werden NICHT über die Änderung der Uhrzeit informiert.',
  },
  event: {
    faildToCreate: 'Event konnte nicht erstellt werden.',
    eventCouldNotBeLoaded: 'Event konnte nicht geladen werden.',
    createdNewEvent: 'Event wurde erstellt',
    eventNotUpdated: 'Die Änderungen konnten nicht gespeichert werden.',
    eventUpdated: 'Änderungen wurden gespeichert.',
  },
  events: {
    eventsCouldNotBeLoaded: 'Events konnten nicht geladen werden.',
  },
  entityTranslation: {
    entityNotCreated: 'Übersetzung konnte nicht gespeichert werden.',
  },
  createBookingOverview: {
    createNewBooking: 'Buchen',
    cancelBooking: 'Buchung abbrechen',
    atLeasOneBasketEntryRequired:
      'Sie müssen mindestens ein Produkt in den Warenkorb legen.',
    confirmAndBook: 'Buchung bestätigen',
    bookingConfirmation: 'Buchungsbestätigung',
    customerPayed: 'Geld einkassiert!',
  },
  createBooking: {
    selectProductOrEvent: 'Produkt oder Event',
    availableCapacity: 'Kapazitäten',
    amountOfProducts: 'Anzahl davon in den Warenkorb',
    composeProduct: 'Datum und Produkt wählen',
    selectPerson: 'Hauptkunde wählen',
    addToBasket: 'Dem Warenkorb hinzufügen',
    productOrEventMandatory: 'Produkt oder Event auswählen.',
    amountMandatory: 'Anzahl eingeben.',
    productOrEventShort: 'Produkt/Event',
    insufficientCapacities:
      'Nicht genügend Kapazitäten vorhanden. Sie können die Kapazitäten für diesen Tag erhöhen oder unverbindlich auf die Warteliste buchen.',
    waitingList: 'Buchung auf Warteliste setzen',
    noSuchProductCombination:
      'Diese Produktkombination existiert nicht! Bitte die Produktdetails anpassen.',
    incl: 'Inklusive',
    changeBooking:
      'Soll die Buchung auf einen anderen Hauptkunden lauten? Dann müssen Sie den Warenkorb leeren oder eine neue Buchung erfassen.',
    hint:
      'Tipp: Sie können die einzelnen Tickets unten im Warenkorb einem anderen Benutzer zuordnen.',
    productDetails: 'Produktdetails',
    productSoldOut: 'Das Produkt ist für diese Anzahl Personen ausgebucht.',
    selectProduct: 'Wählen Sie ein Produkt',
    dateNotAvailableForSelectedProduct:
      'Wir haben das Datum automatisch angepasst.',
    eventNotAvailableOnThisDate:
      'Der Event ist an diesem Datum nicht verfügbar!',
    saveChanges: 'Änderung speichern',
  },
  bookingByCustomerSearch: {
    userHasBookings:
      '{user} hat keine Buchungen bisher. | {user} hat bereits {bookings} Buchungen. Einblenden. | {user} hat bereits {bookings} Buchung. Einblenden.',
    hideBookings: 'Buchungen ausblenden',
    unpaid: 'Unbezahlt',
  },
  bookingConfirmation: {
    arrivalTime: 'Ankunftszeit (ungefähr)',
    bookingStateMandatory: 'Bitte wählen Sie einen Buchungsstatus.',
    sendMail: 'Buchungsbestätigung senden',
    doNotSendMail: 'Keine Buchungsbestätigung',
    internalRemark: 'Bemerkung (intern)',
    selectPerson: 'Person wählen',
    thisIsTheBookingPerson: 'Buchung lautet auf diese Person',
    confirmationForThisPerson: 'Mailbestätigung wird an diese Person versandt.',
    bookingUser: 'Buchung für',
    mailRequired: 'Mail für gewählte Person fehlt.',
  },
  sTextEditor: {
    contentRequired: 'Bitte einen Text für die Buchungsbestätigung erfassen.',
  },
  adminCheckout: {
    checkoutFailed: 'Die Buchung konnte leider nicht erstellt werden!',
    sendingMailFailed:
      'Die Buchungsbestätigung konnte leider nicht versendet werden.',
    bookingCreated: 'Buchung wurde erstellt.',
    confirmationMailSent: 'Buchungsbestätigung wurde versendet.',
    capacitySoldOut:
      'Jemand ist Ihnen zuvorgekommen. Eines Ihrer Produkte wurde in der Zwischenzeit ausverkauft. Die Buchung wurde nicht erstellt!',
    productInactive:
      'Eines der Produkte im Warenkorb wurde in der Zwischenzeit inaktiv gestellt und kann daher nicht mehr gebucht werden.',
  },
  bookingState: {
    change: 'Status ändern',
    changeBookingState: 'Möchten Sie den Buchungsstatus ändern?',
    undoImpossible:
      'Achtung: Diese Änderung kann nicht rückgängig gemacht werden!',
    stateChanged: 'Buchungsstatus geändert',
  },
  bookingStates: {
    stateCouldNotBeChanged:
      'Der Status konnte nicht geändert werden. Möglicherweise wird die Kapazitätslimitierung überschritten.',
  },
  paymentDetails: {
    customerPaid: 'Kunde hat bezahlt',
    didCustomerPaid: 'Betrag einkassiert?',
    amountReceived:
      'Der Betrag über <span class="font-weight-black">{amount}</span> wurde einkassiert.',
    changeBookingStateFirst: 'Buchungsstatus ändern, um Betrag einzukassieren!',
    printGroupReceipt: 'Gruppen-Beleg',
    groupDiscounts: 'Gruppenrabatte',
    payCashFromShopForbidden: 'Unbezahlte Shop-Buchung',
  },
  groupReceipt: {
    groupReceipt: 'Buchungsbeleg',
    peopleCount: 'Anzahl Personen: {peopleCount}',
    group: 'Gruppe',
  },
  printTickets: {
    printTickets: 'Tickets drucken',
    valid: 'Gültig',
    barcodeError: 'Fehler: Barcode konnte nicht generiert werden.',
    reason: 'Grund',
    novatouchError: 'Novatouch-Fehler',
    co2Compensation: 'CO2-Kompensation',
    cwcExplanation: 'Mehr Informationen unter causewecare.ch',
    bookingNumber: 'Buchungs-Nr. {bookingNumber}',
    niesenReservationHint:
      'Bitte begeben Sie sich 10 Minuten vor Abfahrt zum Gruppeneingang (Signalisation beachten). ' +
      'Beachte, dass Sie zusätzlich ein reguläres Bahnbillet benötigen.',
  },
  priceBulkManagement: {
    gotoBtn: 'Preise übersteuern',
    editRules: 'Regeln festlegen',
    surcharge: 'Prozentuale Preisänderung',
    absoluteSurcharge: 'Absolute Preisübersteuerung',
    chooseProducts: 'Produkte Auswählen',
    surchargeModeAbs: 'Selektierte Produkte mit absolutem Betrag überschreiben',
    surchargeModePerc: 'Prozentualer Preisauf oder -abschlag',
    amount: 'Betrag',
    percent: 'Prozent',
    resetPrices: 'Preise zurücksetzen',
    reset: 'Zurücksetzen',
    submit: 'Anwenden',
    repeat: 'Wiederholen',
    repeatEvery: 'Wiederhole jeden',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    preview: 'Einzelselektierung / Vorschau',
    explanation:
      'Die regelbasierte Auswahl kann manuell angepasst und übersteuert werden.',
    youAreOverriding: 'Preise überschreiben',
    overwritePrice: 'Preise überschreiben',
    youOverridePrices: 'Sie sind im Begriff, folgende Preise zu überschreiben',
    priceChange: 'Prozentuale Preisänderung für alle selektierten Produkte',
    absoluteChange: 'Neuer Preis für alle selektierten Produkte',
    priceReset:
      'Der Preis wird für alle Produkte auf den Standardwert zurückgesetzt',
    atDates: 'An den Daten',
    resetPricesTitle: 'Preise zurücksetzen',
    youResetPrices: 'Sie sind im Begriff, die Preise zurückzusetzen',
    repeatEveryWeekday: '-en Wochentag',
    overwrite: 'Überschreiben',
    failedOverwriting: 'Überschreiben der Preise fehlgeschlagen',
    failedReverting: 'Zurücksetzen der Preise fehlgeschlagen',
    failedLoadingCustomPrices: 'Laden der Preise fehlgeschlagen',
    successOverridePrices: 'Preise erfolgreich überschrieben',
    successResetPrices: 'Preise erfolgreich zurückgesetzt',
    newPrice: 'Neuer Preis',
    oldPrice: 'Alter Preis',
    priceDifference: 'Differenz',
    calculating: 'Berechne Preise, dies kann einen Moment dauern ...',
    product: 'Produkt',
    filter: 'Nach Produkten filtern...',
    overrideWithZero:
      'Achtung! Der Preis wird mit 0 überschrieben. Sind Sie sicher, dass sie dies tun wollen?',
  },
  shopBookingCalendar: {
    selectProducts: 'Wähle Produkte aus',
    others: 'anderes',
  },
  shopOverview: {
    noProductDefinitionProvided:
      'Leider konnte kein passendes Produkt gefunden werden.',
    scrollHint: 'Scrollen, um mehr Erlebnisse anzuzeigen',
    groupRequests: 'Gruppenanfragen',
  },
  bookingComplete: {
    excelDownload: 'Liste Exportieren',
    bookings: 'Buchungen',
    people: 'Personen',
  },
  datePersonCarousel: {
    available: 'Noch {capacities} verfügbar',
    selectAmountOfPeople: 'Anzahl Personen wählen',
    loadingSelection: 'Bitte warten...',
    maxAvailableTickets:
      'Plätze ausverkauft | max. 1 Platz verfügbar | max. {stockLeft} Plätze verfügbar',
    availableTickets:
      'Plätze ausverkauft | 1 Platz verfügbar | {stockLeft} Plätze verfügbar',
  },
  basket: {
    peopleCount: '{peopleCount} Person | {peopleCount} Personen',
    sledgeCount: '{peopleCount} Schlitten | {peopleCount} Schlitten',
    dogCount: '{peopleCount} Hund | {peopleCount} Hunde',
    checkout: 'Zur Kasse',
    addBasketEntries: 'Es befinden sich noch keine Produkte im Warenkorb',
    causeWeCareNotUpdated:
      'Die CO2-Kompensation konnte leider nicht hinzugefügt werden.',
    inclCo2Compensation: 'Inkl. CO2-Kompensation',
    causeWeCare: 'Cause We Care',
    add: 'Hinzufügen',
    requiredEntryCannotBeDeleted:
      'Diese Produkt kann nicht entfernt werden, weil es zu einem anderen Produkt im Warenkorb gehört.',
    offered: 'Offeriert',
    nonRefundableCardFee: 'inkl. {fee} Kartengebühr',
  },
  productPresenter: {
    start: 'Beginn',
    end: 'Ende',
    unfold: 'Weitere Informationen',
    fold: 'Weniger Informationen',
    jumpToDate: 'Datum wählen',
  },
  productCategories: {
    train: 'Bahnfahrten',
    tableReservation: 'Tischreservationen',
    gastro: 'Kulinarische Angebote',
    events: 'Event-Vorlagen',
    rooms: 'Seminare & Feiern',
    required: 'Required',
    hotel: 'Hotel & Übernachtungen',
    request: 'Anfragen',
    requestForm: 'Gruppen-Anfragen',
    niesenExclusive: 'Exklusiv',
    reservation: 'Reservationen',
    seasonabo: 'Saison-Abonnemente',
    voucher: 'Gutscheine',
    ski: 'Ski',
    singlerides: 'Einzelfahrten',
    crowdFunding: 'Crowdfunding',
    winterabo: 'Winterkarten',
    winterAbo: 'Winterkarten',
    summerabo: 'Sommerkarten',
    yearabo: 'Jahreskarten',
    pistenBully: 'Alpuschnaager',
    points: 'Punktekarten',
    sledge: 'Schlitteltickets',
    pedestrian: 'Fussgänger',
    hiking: 'Wandertickets',
    bikepark: 'Bikepark',
    summerOffers: 'Sommerangebote',
    experiences: 'Erlebnisse',
    winteraboSki: 'Winterabos Ski',
    yearaboPedestrian: 'Jahresabos Fussgänger',
    sendingcostPerBooking: 'Versandkosten',
    insurance: 'Versicherung',
    transportInPackage: 'Transport',
    printse: 'Printse',
    '4_vallées': '4 Vallées',
    fee: 'Versandkosten',
    summeraboNendaz: 'Sommerabo',
    winteraboSkiNendaz: 'Jahresabos (Winter + Sommer 2023)',
    yearaboPedestrianNendaz: 'Abo Fussgänger (Winter + Sommer 2023)',
    royalrides: 'Royal Ride',
    promotions: 'Promotion',
  },
  adminBasket: {
    groupDiscount: 'Rabatt',
    createGroupDiscountFailed: 'Gruppenrabatt konnte nicht erstellt werden.',
    discountType: 'Rabatt-Typ',
    discountDescription: 'Beschreibung Rabatt',
    selectDiscountType: 'Wähle den Rabatt-Typ',
    provideDiscountDescription: 'Weshalb der Rabatt?',
    insertDiscountAmount: 'Wie hoch soll der Rabatt ausfallen?',
    couldNotDeleteGroupDiscount: 'Gruppen-Rabatt konnte nicht gelöscht werden.',
    netWithoutVat: 'Netto ohne MwSt.',
    vat: 'MwSt.',
    totalInclVat: 'Total inkl. MwSt.',
    incl: 'Inkl.',
    withCauseWeCare: 'Mit CO2-Kompensation',
    withoutCauseWeCare: 'Ohne CO2-Kompensation',
    fetchingBasketFailed: 'Warenkorb konnte nicht geladen werden.',
    addProduct: 'Produkt hinzufügen',
    saveChanges: 'Änderungen speichern',
  },
  discountTypes: {
    absolute: 'Absolut (CHF)', // not in use
    relative: 'Relativ (%)',
  },
  contactForm: {
    yourMessage: 'Ihre Nachricht',
    messageRequired: 'Bitte beschreiben Sie Ihre Anfrage',
  },
  sendRequest: {
    summary: 'Zusammenfassung',
    sendRequest: 'Abfrage absenden',
    request: 'Anfrage',
    senderContact: 'Kontakt des Absenders:',
  },
  formRequest: {
    sendingFailed: 'The message could not be sent.',
    requestSent: 'Ihre Nachricht wurde uns zugestellt.',
  },
  bookingsComplete: {
    roomNumber: 'Zimmer-Nummer',
  },
  bookingEntry: {
    saveAllocationNumberFailed:
      'Die Zuteilung konnte nicht gespeichert werden.',
  },
  checkoutNavigation: {
    compensateCo2: 'CO2 kompensieren',
    payNow: 'Jetzt bezahlen',
    capacitySoldOut:
      'Jemand ist Ihnen zuvorgekommen. Eines Ihrer Produkte wurde in der Zwischenzeit ausverkauft. ' +
      'Ihre Buchung konnte nicht abgeschlossen werden. Ihr Konto wurde nicht belastet.',
    productInactive:
      'Eines der Produkte im Warenkorb ist leider nicht mehr verfügbar.',
    accommodationTax: 'Kurtaxe/Beherbergungsabgabe bitte im Berghaus bezahlen',
    voucherNotValidated:
      'Der von Ihnen angegebene Voucher wurde noch nicht hinzugefügt. Fügen Sie diesen hinzu oder ' +
      'oder entfernen Sie ihn um fortzufahren.',
    niesen: {
      oldVoucherTitle: 'Den alten Niesen-Gutschein einlösen - leicht gemacht',
      oldVoucherText:
        'Um einen älteren Gutschein (vgl. Foto) online einlösen zu können, können Sie den QR-Code (vgl. rote Umrandung auf dem Foto) mit einer ' +
        'Handy-Kamera scannen. Die Handy-Kamera wird Ihnen einen Code ' +
        'anzeigen. Diesen Code können Sie oben ins Feld übertragen ' +
        '("Online-Guthaben-Code eingeben"). ' +
        '<b>Die aufgedruckte Buchungsnummer kann online nicht eingegeben werden.</b>',
    },
  },
  imageUploader: {
    required: 'Eine Datei muss ausgewählt sein.',
    wrongFileType: 'Nur .png und .jpg unterstützt',
  },
  singleReport: {
    noContent: 'Keinen Inhalt',
    roomNumber: 'Zimmer-Nummer',
    details: 'Details',
    total: 'Total',
    peopleOverAll: 'Personen (alle Zeiten)',
    totalPeople: 'Personen',
    reservations: 'Reservationen',
    events: 'Veranstaltungen',
    event: 'Veranstaltung',
    groups: 'Bahn',
    product: 'Leistung',
    maxPlaces: 'Reservierte/Maximale Plätze',
    noLimitation: 'Keine Beschränkung',
    tel: 'Tel.',
  },
  extendedAttribute: {
    saveFailed: 'Speichern fehlgeschlagen',
  },
  salutation: {
    m: 'Herr',
    f: 'Frau',
  },
  settingsOverview: {
    manageRoles: 'Rollen verwalten',
    productsImport: 'Produkte importieren',
    changeCurrency: 'Währung ändern',
    axessSeasonCreation: 'Neue Saison bei Axess initialisieren',
    powerBi: 'Power BIs verwalten',
  },
  powerBiManagement: {
    noDataAvailable: 'Es sind keine Power BIs für diese Region vorhanden.',
    connectPowerBis: 'Welche Rolle darf welches BI sehen?',
    editPowerBis: 'BI erstellen & bearbeiten',
  },
  UsersRoles: {
    couldNotBeLoaded: 'Benutzer konnten nicht abgerufen werden.',
  },
  roleManagement: {
    user: 'Benutzer',
    role: 'Rolle',
    addNewRole: 'Neuem Benutzer eine Rolle zuteilen',
    userAlreadyAdded:
      'Ausgewählter Benutzer hat bereits Rollen zugeteilt. Sie finden ihren Namen oben in der Liste.',
  },
  roles: {
    couldNotBeLoaded: 'Rollen konnten nicht abgerufen werden.',
    couldNotBeLinked: 'Rolle konnte dem Benutzer nicht hinzugefügt werden!',
    couldNotBeDeleted: 'Rolle konnte dem Benutzer nicht entzogen werden!',
  },
  shopHandler: {
    shopClosed: 'Der Online-Shop ist derzeit geschlossen.',
  },
  paymentTotalListing: {
    taxNr: 'MwSt-Nummer',
    cancelledServices: 'Stornierte Leistungen',
  },
  bookingAggregated: {
    noCapacityLimit: 'Keine Kapazitätsbeschränkung',
  },
  pricingOverridePrices: {
    notInValidityDates:
      'Das Produkt ist nicht an all Ihren ausgewählten Tagen verfügbar. Nicht verfügbare Tage werden bei der Preisüberschreibung ignoriert!',
  },
  eventSection: {
    knowMore: 'Mehr erfahren',
  },
  sectionTitle: {
    events: 'Einzigartige Events',
    customService: 'Massgeschneiderte Angebote',
    extraordinaryExperiences: 'Aussergewöhnliche Bergerlebnisse',
    requests: 'Anfragen',
  },
  bookingPaid: {
    backToCashDesk: 'Zurück zur Kasse',
  },
  fontAwesomeSelect: {
    selectLabel: 'Icon',
  },
  appHeader: {
    goToBackendShop: 'Ins Shop-Backend',
    goToBackendPe: 'Zur Pricing-Engine',
  },
  translationIcons: {
    addIcon: 'Icon hinzufügen',
  },
  fileUploadService: {
    processingExcel: 'Produkte werden importiert. Dies kann eine Weile dauern.',
    importSucceed: 'Produkte-Import war erfolgreich!',
  },
  productsImport: {
    fileInputLabel: 'Excel auswählen',
    required: 'Bitte wählen Sie eine Excel-Datei, die importiert werden kann.',
    wrongFileType: 'Nur .xlsx-Datei-Format unterstützt',
    upload: 'Hochladen',
    reallyImport: 'Produkte überschreiben?',
    importCannotBeUndone:
      'Die Produkte und ihre Eigentschaften werden unwiederbringlich überschrieben. Dieser Vorgang' +
      ' kann nicht rückgängig gemacht werden!',
    overwrite: 'Überschreiben',
    selectDestination: 'Wählen Sie eine Destination',
    wrongFileName: 'Dateiname entspricht nicht dem Gebietsnamen.',
  },
  changeCurrency: {
    changeLable: 'Währung ändern',
    currency: 'Währung',
    currencyNotEmpty: 'Es muss eine Währung gesetzt sein.',
    changeSuccess: 'Währung wurde erfolgreich geändert.',
  },
  reportsOverview: {
    bookings: 'Export Buchhaltung / Cause We Care',
    bookings_filename: 'Buchungen_Cause_We_Care_',
    cwc: 'CWC',
    accounting: 'Buchungen',
    from: 'Von',
    to: 'Bis',
    required: 'Benötigt',
    export: 'Export',
    loadingDataFailed: 'Fehler beim Laden der CWC/Buchungsdaten',
    idBooking: 'ID der Gesamtbuchung',
    vat: 'MWST auf CWC (7.7%)',
    cash: 'Kasse',
    six_saferpay: 'SIX',
    moreOrEquals: '"Bis" muss grösser gleich "Von" sein',
    lessOrEquals: '"Von" muss kleiner gleich "Bis" sein',
    noData: 'Keine Daten im gewählten Zeitraum',
    accountingHeaders: {
      bookingId: 'ID der Gesamtbuchung',
      bundelId: 'ID des Produktbündels',
      id: 'ID des Einzelnen Produktes (innerhalb des Bündels)',
      product: 'Produkt',
      productDefinition: 'Details',
      customer: 'Kunde',
      mail: 'E-mail',
      start: 'Gültigkeitsstart',
      end: 'Gültigkeitsende',
      state: 'Buchungsstatus',
      paymentType: 'Zahlungsart',
      note: 'Bemerkung',
      currency: 'Währung',
      netPrice: 'Betrag netto',
      grossPrice: 'Betrag brutto',
      vat37: 'MWST 3.7%',
      vat77: 'MWST 7.7%',
      cancelAmount: 'Stornierung',
      cancelDate: 'Stornierungsdatum',
      clearedNetPrice: 'bereinigter Betrag netto',
      clearedGrossPrice: 'bereinigter Betrag brutto',
      clearedVat37: 'bereinigte MWST 3.7%',
      clearedVat77: 'bereinigte MWST 7.7%',
      bookingDate: 'Buchungsdatum',
      paymentTime: 'Zahlungszeit',
    },
  },
  seatReservation: {
    stepperHeaderText: 'Bahnreservation',
    earlier: 'früher',
    later: 'später',
    reserveNow: 'Jetzt reservieren',
    seatsAvailable: 'Plätze verfügbar',
    warningText: {
      niesen: 'Ohne Reservation kann es an Spitzentagen zu Wartezeiten kommen.',
      moosalpregion:
        'Ohne Platzreservation können wir Ihnen keinen Sitzplatz im Alpuschnaager gewährleisten.',
    },
    soldOut: {
      moosalpregion:
        'Alle Plätze sind ausverkauft. Ohne Reservation ist die Fahrt nicht garantiert und lange Wartezeiten sind möglich.',
      niesenTooLate:
        'Bahnreservationen sind nur bis 6.00 Uhr am Gültigkeitstag möglich. Sie können die Bahn aber ' +
        'auch ohne Reservation benützen. Ohne Reservation kann es an Spitzentagen zu Wartezeiten kommen.',
      niesen:
        'Für das gewählte Datum sind keine Bahnreservationen mehr möglich. Sie können die Bahn aber auch ' +
        'ohne Reservation benützen. Ohne Reservation kann es an Spitzentagen zu Wartezeiten kommen.',
    },
    productTexts: {
      niesen: ['Bergfahrt', 'Talfahrt'],
    },
    selectTime: 'Zeit finden',
    inTo: 'In den',
    continueWithoutReservation: 'Ohne Reservation fortfahren',
    youWillRedirectedShortly:
      'Prüfe Reservationen. Sie werden gleich weitergeleitet.',
    nextStepAnyway: 'Trotzdem weiter',
  },
  products: {
    overrideFailed: 'Die Kapazitäten konnten nicht geändert werden.',
    capacitiesOverriden: 'Die Kapazitäten wurden geändert.',
    capacityOverrideTakesAWhile:
      'Die Kapazitäten werden überschrieben. Dies kann mehrere Minuten dauern.',
    archive: 'Archiv',
  },
  capacityOverride: {
    noDatesSelected:
      'Wählen Sie die Wochentage im Kalender, an denen die Kapazität geändert werden soll.',
    setCapacityAmount: 'Neue Kapazität eingeben.',
    noCapacitiesSelected: 'Kapazitäten auswählen.',
    reallyChange: 'Kapazitäten wirklich ändern?',
    willBeOverwrittenOn: 'An folgenden Daten',
  },
  capacityBellowWarning: {
    bellowWarning: 'Kapazität unter Buchungen',
  },
  shortCutSeasonAbos: {
    summer: 'Saisonkarten Sommer',
    winter: 'Saisonkarten Winter',
    family: 'Saisonkarten Familien',
    selectSeasonMandatory: 'Bitte wählen Sie den Abo-Typ aus.',
    selectSeason: 'Abo-Typ auswählen',
    pointCards: 'Punktekarten',
  },
  shortCutSledge: {
    selectRoute: 'Strecke wählen',
  },
  seasonAbos: {
    bookNow: 'Jetzt buchen',
    noProductAvailable: 'Kein Produkt an diesem Datum verfügbar.',
  },
  priceHistory: {
    viewTitle: 'Historischer Preisverlauf',
    timespan: 'Zeitspanne',
    sevenDays: 'Letzte 7 Tage',
    fourteenDays: 'Letzte 14 Tage',
    thirtyDays: 'Letzte 30 Tage',
    seasonStart: 'Seit Saisonstart',
    all: 'Alle',
    skiDay: 'Skitag',
    priceHistory: 'Preisverlauf',
  },
  currentPostedPricesChart: {
    ylabel: 'Preis',
    lastCalcDate: 'Letzte Preisberechnung',
  },
  dailyBaseRateChart: {
    ylabel: 'Daily Base Rate in',
    overlayText: 'Daily Base Rate:',
  },
  productTargetPriceChart: {
    ylabel: 'Product Target Price',
  },
  cashDeskPriceChart: {
    ylabel: 'Cash Desk Price',
  },
  multiDayDiscountChart: {
    ylabel: 'Target Product Price',
    overlayText: 'Daily Base Rate: CHF', // not in use
    multiDayDiscountLabel: 'Multi Day Discount',
    productTargetPrice: 'Target Product Price',
    currentPostetPrice: 'Current Posted Price',
  },
  maxEarlyBookingChart: {
    ylabel: 'Current Posted Price',
    factorAxis: 'Current Early Booking Discount',
    priceAxis: 'Current Posted Price',
  },
  cashDaskPriceModal: {
    title: 'Cash Desk Price',
    currentPrice: 'Aktueller Cash Desk Price',
    difference: 'Veränderung',
    newPrice: 'Neuer Cash Desk Price',
    min: 'Min Cash Desk Price',
    max: 'Max Cash Desk Price',
  },
  baseOverwriteModal: {
    abort: 'abbrechen',
    overwrite: 'überschreiben',
    notPossible: 'Die Vergangenheit kann nicht bearbeitet werden',
    overMaximum: 'Wert liegt über Maximum',
    belowMinimum: 'Wert liegt unter Minimum',
    reset: 'zurücksetzen',
  },
  multiDayDiscountOverwriteModal: {
    title: 'Target Product Price',
    max: 'Max Multi-Day Discount',
    min: 'Min Multi-Day Discount',
    dailyBaseRate: 'Daily Base Rate',
    multiDayDiscountFactor: 'Multi-Day Discount Factor',
    productTargetPrice: 'Product Target Price',
    valueAndDemandFactor: 'Value And Demand Factor',
    currentPostedPrice: 'Current Posted Price',
    targetPriceTooLow:
      'Der neue Current Posted Price ist tiefer als der vorangehende. Urspünglicher Wert: {val}',
    from: 'Tage ab',
    infoBox:
      'Die Änderungen am Target Price werden erst nach der nächsten Preiseberechnung sichtbar',
    noSlider: 'Der Slider ist nicht verfügbar',
    basicPriceOverview: 'Basispreisübersicht',
    multiDayDiscount: 'Mehrtagesrabatt',
    multiDayDiscountFacotrHelp: 'Mehrtagesrabatt-Faktor',
    roundDiff: 'Rundungsdifferenz',
  },
  dailyBaseRateOverwriteModal: {
    title: 'Daily Base Rate für den',
    max: 'Max Daily Base Rate',
    min: 'Min Daily Base Rate',
    dailyBaseRate: 'Aktuelle Daily Base Rate',
    change: 'Veränderung',
    newDailyBaseRate: 'Neue Daily Base Rate',
    infoBox:
      'Die Änderungen an der Daily Base Rate werden erst nach der nächsten Preiseberechnung sichtbar',
    basicPriceOverview: 'Basispreisübersicht',
    workload: 'Erwartete Auslastung:',
    notOkWithDailyBR: 'Nicht zufrieden mit der Daily Base Rate?',
  },
  earlyBookingOverwriteModal: {
    title: 'Current Posted Price',
    max: 'Max Early Booking Discount',
    min: 'Min Early Booking Discount',
    dailyBaseRate: 'Daily Base Rate',
    earlyBookingFactor: 'Early Booking Discount Factor',
    productTargetPrice: 'Product Target Price',
    valueAndDemandFactor: 'Value And Demand Factor',
    currentPostedPrice: 'Current Posted Price (vor Strukturelement)',
    cashDeskPrice: 'Cash Desk Price',
    targetPriceTooLow:
      'Der neue Current Posted Price ist tiefer als der vorangehende. Urspünglicher Wert: {val}',
    from: 'Tage ab',
    infoBox:
      'Die Änderungen am Current Posted Price werden erst nach der nächsten Preisberechnung sichtbar.',
    noSlider: 'Der Slider ist nicht verfügbar',
    valDem: 'Value & Demand',
    currentEarlyBookingDiscount: 'Aktueller Early Booking Discount',
    realizedDemandFactor: 'Realized Demand Factor',
    timeFactor: 'Time Factor',
    multiDayDiscount: 'Multi-Day Discount Factor',
  },
  bookmarks: {
    title: 'Favoriten Listen',
    newList: 'Neue Favoritenliste',
    noLists: 'Sie haben keine Favoriten-Liste erstellt.',
    listName: 'Name der Liste',
    create: 'Erstellen',
    required: 'Benötigt',
    maxChars: 'Maximale Anzahl Buchstaben erreicht.',
    notUnique: 'Liste existiert bereits.',
    editLists: 'Favoriten bearbeiten',
    abort: 'Abbrechen',
    back: 'Zurück',
    removeList: 'Löschen',
    noProdDefs: 'Keine Einträge',
    editListsTitle: 'Favoriten bearbeiten',
    addListTitle: 'zu Favoriten hinzufügen',
    bookmarkFilter: 'Favoriten',
  },
  realizedDemandChart: {
    overlayText: 'Anzahl Verkäufe:',
    yAxisLabel: 'Realisierte Nachfrage',
  },
  crowdFunding: {
    title: 'Unterstützen Sie den Bau der 6er-Sesselbahn',
  },
  priceOverrideEvents: {
    selectProductDefinitions: 'Produktausprägung wählen',
    description: 'Ausprägung',
    newPrice: 'Neuer Preis',
    newPriceRequired: 'Bitte neuen Preis eingeben.',
    override: 'Überschreiben',
    noSelectedProductDefinitions:
      'Wählen Sie mindestens eine Produktausprägung aus.',
    noDateGiven: 'Unerwarteter Fehler: Kein Datum',
  },
  // stepper header texts
  stepperHeader: {
    chaeserrugg: {
      componentLevel: {
        Basket: {
          modalContent:
            '<p><strong>Nach Alter</strong></p>\n' +
            '<p><strong>Erwachsen: </strong>ab 20 Jahren <br /> <strong>Senior:</strong> ab 65 Jahren <br /> <strong>Jugendlich:</strong> 16 &ndash; 19 Jahre<br /> <strong>Kind:</strong> 6 &ndash; 15 Jahre<br /> </p>\n' +
            '<p>F&uuml;r die Altersabgrenzung ist der erste G&uuml;ltigkeitstag des Tickets entscheidend.</p>\n' +
            '<p>&nbsp;</p>\n' +
            '<p><strong>Tagesskipass mit SBB GA</strong></p>\n' +
            '<p>Inhaber eines Generalabonnements der SBB erhalten rund 20% Reduktion auf die 1- und 2-Tagesskip&auml;sse. Dieser Rabatt kann bei der Personalisierung der Skitickets (sp&auml;ter im Buchungsprozess) ausgew&auml;hlt werden. Dabei muss das Skiticket allerdings zwingend auf den SwissPass geladen werden. <br /> </p>\n' +
            '<p><strong>Speziell f&uuml;r Familien</strong><br /> Familien profitieren von speziellen Konditionen f&uuml;r Kinder ab einem 3-Tagespass. Ein Familientarif kommt nur zur Anwendung, wenn der Kinderskipass mit mindestens einem Elternteil gel&ouml;st wird.</p>',
        },
        SeasonAbos: {
          modalContent:
            '<p><strong>Winterkarte</strong></p>\n' +
            '<p><strong>Erwachsen: </strong>ab 20 Jahren <br /> <strong>Senior:</strong> &nbsp;diese Kategorie gibt es bei den Abonnementen nicht <br /> <strong>Jugendlich:</strong> 16 &ndash; 19 Jahre<br /> <strong>Kind:</strong> 6 &ndash; 15 Jahre</p>\n' +
            '<p>Mit der Winterkarte k&ouml;nnen Sie das Ch&auml;serrugg Gebiet den ganzen Winter &nbsp;geniessen: Skifahren, Schlitteln, Langlaufen, Winterwandern sowie die Bahnanteile bei Vollmond Dinners und das Nachtskifahren sind inklusive.</p>\n' +
            '<p>&nbsp;</p>\n' +
            '<p><strong>Winterkarte (Montag-Freitag)</strong></p>\n' +
            '<p><strong>Erwachsen: </strong>ab 20 Jahren <br /> <strong>Senior:</strong> &nbsp;diese Kategorie gibt es bei den Abonnementen nicht <br /> <strong>Jugendlich:</strong> 16 &ndash; 19 Jahre<br /> <strong>Kind:</strong> 6 &ndash; 15 Jahre</p>\n' +
            '<p>Mit der Winterkarte Mo-Fr k&ouml;nnen Sie w&auml;hrend den Wochentagen von Montag bis Freitag das Ch&auml;serrugg Gebiet geniessen. An Wochenenden (Samstag und Sonntag) ist dieses Abonnement nicht g&uuml;ltig. Falls Sie trotzdem mal an einem Wochenende kommen m&ouml;chten, k&ouml;nnen Sie gerne eine Tageskarte dazu buchen.</p>\n' +
            '<p>&nbsp;</p>\n' +
            '<p><strong>Winterkarte Familien</strong></p>\n' +
            '<p><strong>Erwachsen: </strong>ab 18 Jahren <br /> <strong>Kinder :</strong> bis 17.99 Jahre</p>\n' +
            '<p>Als Familien profitieren Sie von der attraktiven Familienkarte. Im Preis der Familienkarte sind maximal 2 Erwachsene plus eine beliebige Anzahl Kinder im gleichen Haushalt lebend bis 17.99 Jahre inklusive. Der Stichtag f&uuml;r das Alter bei Winterkarten ist der Start des t&auml;glichen Betriebs der Bergbahnen (z.B. Start t&auml;glicher Betrieb am 15.12: Kinder, die bis zum 15.12. noch unter 16-Jahre alt sind, erhalten noch den Kinder-Tarif.)</p>',
        },
      },
      specificModuleComponentLevel: {
        hikingChaeserrugg: {
          SeasonAbos: {
            headerText: 'Informationen zu den Tickets',
            modalTitle: 'Informationen zu den Tickets',
            modalContent:
              '<p><strong>Alterskategorien</strong></p>' +
              '<p>Erwachsen: ab 16 Jahren</p>' +
              'Kinder: 6 - 15 Jahren' +
              '<p>&nbsp;</p>' +
              '<p><strong>SBB GA- und HTX Ermässigungen</strong></p>' +
              'Die SBB GA- und HTX Ermässigungen können beim Zahlungsprozess geltend gemacht werden.' +
              '<p>&nbsp;</p>' +
              '<p><strong>Wander-Ticket</strong></p>' +
              'Gültig für drei Strecken auf der Achse Unterwasser–Iltios–Chäserrugg. Wenn Sie z.B. von Unterwasser mit der Bahn aufs Iltios fahren, von dort auf den Chäserrugg wandern und anschliessend mit der Bahn vom Gipfel zurück bis nach Unterwasser fahren.' +
              '<p>&nbsp;</p>' +
              '<p><strong>Churfirsten-Ticket</strong></p>' +
              '1 Berg- und 1 Talfahrt Unterwasser–Iltios oder Alt St. Johann–Sellamatt, 1 Postautofahrt zwischen Unterwasser und Alt St. Johann. Wenn Sie z.B. von Alt St. Johann mit der Bahn auf die Alp Sellamatt fahren, bis zum Iltios wandern und von dort mit der Standseilbahn nach Unterwasser fahren.' +
              '<p>&nbsp;</p>' +
              '<p><strong>Wandertageskarte</strong></p>' +
              'Benutzung sämtlicher Bergbahnen im Chäserrugg Gebiet inkl. Postauto zwischen Unterwasser und Alt St. Johann. Wenn Sie z.B. von Alt St. Johann zur Alp Sellamatt fahren, von dort über den Hinterrugg zum Chäserrugg wandern und dann mit der Bahn vom Gipfel bis nach Unterwasser fahren.' +
              '<p>&nbsp;</p>' +
              '<p><strong>Textilausstellung-Ticket</strong></p>' +
              'Das Wander-Ticket zur Ausstellung der STF am Chäserrugg berechtigt zu Bahnfahrt auf 3 Strecken (eine Strecke wird zu Fuss zurück gelegt). Ebenfalls können Sie dieses Ticket für einen gratis Eintritt ins Textilmusem St. Gallen nutzen, sowie für einen Schnupperkurs bei der STF.',
          },
        },
        singleRideChaeserrugg: {
          Basket: {
            modalContent:
              '<p><strong>Nach Alter</strong></p>\n' +
              '<p><strong>Erwachsen: </strong>ab 16 Jahren <br /> <strong>Kind:</strong> 6-15 Jahren <br /></p>\n' +
              '<p>Für die Altersabgrenzung ist der erste Gültigkeitstag des Tickets entscheidend.</p>\n' +
              '<p>&nbsp;</p>\n' +
              '<p><strong>SBB Halbtax und GA Ermässigungen</strong></p>\n' +
              '<p>Ermässigungen auf die Einzelfahrten können mit einem gültigen GA oder Halbtax später beim Zahlungsprozess geltend gemacht werden.</p>\n',
          },
        },
      },
    },
    bellwald: {
      componentLevel: {
        Basket: {
          modalContent:
            '<p>Erwachsene: ab 20 Jahren<br />' +
            'Jugendliche: von 16 - 19 Jahren<br />' +
            'Kinder: von 6 - 15 Jahren<br />' +
            'Kleinkinder: von 0 - 5 Jahren fahren in Bellwald GRATIS. Nur am Ticketschalter verfügbar.</p>' +
            'Es gilt das jeweilige Alter zum Nutzungszeitpunkt (1. Gültigkeitstag) <br><br>' +
            '<b>Übertragbarer Skipass für Partner/Eheleute mit Kindern.</b> <br> Mit dem Partner-Pass kann immer nur eine der beiden Personen auf der Piste sein.<br><br>' +
            '<b>Speziell für Familien</b> <br> Das 2. Kind erhält bis zu 20% Ermässigung, das 3. und jedes weitere bis zu 30% Ermässigung (gilt erst ab 3-Tages -Skipass). <br><br>' +
            '<b>Invalidentarif</b> <br> Vergünstigter Tarif für Begleitpersonen von Invaliden. Nur am Ticketschalter verfügbar. <br><br>' +
            '<b>4h-Karte</b> <br> Stundenkarte mit einer zusammenhängenden Gültigkeit von 4 Stunden am Stück. Einlösbarkeit nur über einen Skitag hinweg. Reststunden können nicht am nächsten Tag genutzt werden.',
        },
        CrowdFunding: {
          modalContent:
            '<p>Leisten Sie einen freiwilligen G&ouml;nnerbeitrag zum Neubau der 6er Sesselbahn. Alle Infos zum Projekt finden Sie hier: <a class="sc-dPPMrM bBscpx" title="http://www.bellwald.ch/support" href="http://www.bellwald.ch/support" target="_blank" data-renderer-mark="true"><strong data-renderer-mark="true">ww.bellwald.ch/support</strong></a></p>',
        },
        StandardCalendar: {
          headerText: 'Wählen Sie Ihr Startdatum',
          modalTitle: 'Passende Daten wählen',
          modalContent:
            'Wählen Sie die passenden Daten für Ihr Skivergnügen. Sie können 1 bis maximal 14 Tage auswählen. Sie können die Dauer in der Liste ändern.',
        },
        SeasonAbos: {
          modalContent:
            'Jene Gäste, welche ihr Abo zuerst kaufen, erhalten zusätzlich zum Abo einen Gutschein ' +
            'ihrer Wahl. Sei es eine Skitageskarte für Freunde, Wertgutscheine der Bergbahn oder einen Gutschein aus ' +
            'dem Sportshop. Achtung, die Gutscheine sind nur in limitierter Anzahl vorhanden. <br><br>' +
            'Der <b>Partner-Skipass</b> für Partner/Eheleute ist untereinander übertragbar. Er kann jedoch jeweils ' +
            'nur von einer Person genutzt werden. Eine Übertragung an andere Personen als Partner/Ehepartner ist ausgeschlossen.<br><br>' +
            '<b>Erwachsen</b>: 20 Jahre oder älter<br>' +
            '<b>Jugendlich</b>: 16 - 19 Jahre<br>' +
            '<b>Kind</b>: 6 - 15 Jahre<br>' +
            '<b>Partner</b>: 20 Jahre oder älter<br>' +
            '<b>Kleinkinder</b> erhalten ein kostenloses Skiticket am Schalter',
        },
      },
    },
    moosalpregion: {
      componentLevel: {
        Basket: {
          modalContent:
            '<b>Erwachsene</b>: Jahrgang 1999 und älter <br>' +
            '<b>Jugendliche</b>: Jahrgänge 2000 bis 2004 <br>' +
            '<b>Kinder</b>: Jahrgänge 2005 bis 2011 <br>' +
            '<b>Kleinkinder</b>: Jahrgang 2012 und jünger <br>' +
            '<br><br>' +
            '<b>Speziell für Familien</b> <br>' +
            'Familien profitieren von einem Familienrabatt von 5% wenn min. 1 erwachsene Person ' +
            '(max. 2 erwachsene Personen) in Kombination mit min. zwei zahlenden Kindern (Kategorie Kind oder ' +
            'Jugendlich) gekauft werden.',
        },
        SeasonAbos: {
          modalContent:
            '<b>Erwachsene</b>: Jahrgang 1999 und älter <br>' +
            '<b>Jugendliche</b>: Jahrgänge 2000 bis 2004 <br>' +
            '<b>Kinder</b>: Jahrgänge 2005 bis 2011 <br>' +
            '<b>Kleinkinder</b>: Jahrgang 2012 und jünger <br><br>' +
            '<b>Punktekarten Gültigkeitsdauer:</b> 2 Jahre ab Kaufdatum <br><br>' +
            '<b>Punktekarten-Entwertung</b><br>' +
            '<table style="border-collapse: collapse;" border="solid"><tbody><tr>' +
            '<td width="201">Lift</td>' +
            '<td width="152">Erwachsen / Jugendlich</td>' +
            '<td width="138">Kind</td>' +
            '</tr><tr>' +
            '<td width="201">Kinderlift Bodmen</td>' +
            '<td width="152">1</td>' +
            '<td width="138">1</td>' +
            '</tr><tr>' +
            '<td width="201">Blattlift</td>' +
            '<td width="152">2</td>' +
            '<td width="138">1</td>' +
            '</tr><tr>' +
            '<td width="201">Sesselbahn</td>' +
            '<td width="152">3</td>' +
            '<td width="138">2</td>' +
            '</tr><tr>' +
            '<td width="201">Ronalplift</td>' +
            '<td width="152">3</td>' +
            '<td width="138">2</td>' +
            '</tr><tr>' +
            '<td width="201">Unterratlift</td>' +
            '<td width="152">3</td>' +
            '<td width="138">2</td>' +
            '</tr><tr>' +
            '<td width="201">Moosalplift</td>' +
            '<td width="152">3</td>' +
            '<td width="138">2</td>' +
            '</tr><tr>' +
            '<td width="201">T&ouml;rbeltallift</td>' +
            '<td width="152">3</td>' +
            '<td width="138">2</td>' +
            '</tr></tbody></table>',
        },
        StandardCalendar: {
          modalContent:
            'Wählen Sie die passenden Daten für Ihr Skivergnügen. Sie können die Dauer in der Liste anpassen.',
        },
        PerformanceDifferentiation: {
          modalContent:
            'Mit dem <b>Basic Tarif</b> erwerben Sie ein Skiticket, welches nicht umgebucht oder ' +
            'storniert werden kann. Das Skiticket ist nur für das ausgewählte Datum gültig.' +
            '<br><br>' +
            'Mit dem <b>Flex-Tarif</b> erwerben Sie ein Skiticket, welches flexibel umgebucht werden kann. Sie können ' +
            'das Ticket bis um <b>23:59</b> Uhr vor dem 1. Gültigkeitstag stornieren. Bei einer Stornierung wird die gesamte ' +
            'Buchung storniert. Eine Stornierung einzelner Skitage eines Mehrtagestickets ist nicht möglich. ' +
            'Dabei wird Ihnen der ursprüngliche Buchungsbetrag in Form eines Online-Guthabens gutgeschrieben, ' +
            'welchen Sie bei Ihrer nächsten Online-Buchung einlösen können.' +
            '<br><br>' +
            'Mit dem <b>Wahltarif</b> (z.B. 5 aus 7 Tagen) erwerben Sie ein Ticket, welches Ihnen die Flexibilität ' +
            'gibt, in Ihrem gewählten Zeitraum zwei beliebige Tage auszusetzen, z.B. bei schlechtem Wetter.',
        },
        SeatReservation: {
          headerText: 'Obligatorische Platzreservation',
          modalTitle: 'Was ist eine Sitzplatz-Reservation?',
          modalContent:
            'Die Plätze im Alpuschnaager sind limitiert. Mit einer Alpuschnaager-Reservation garantieren ' +
            'wir Ihnen einen Platz im Alpuschnaager zur ausgewählten Zeit. Wenn Sie eine Alpuschnaager-Reservation ' +
            'gebucht haben, bitten wir Sie, sich spätestens 10 Minuten vor der gebuchten Hinfahrt bei der Egga oder ' +
            'für die Rückfahrt auf der Moosalp mit Ihrem Ticket (Print@Home oder auf dem Handy) einzufinden. Ansonsten ' +
            'kann Ihre Alpuschnaager-Reservation nicht garantiert werden.',
        },
      },
      specificModuleComponentLevel: {
        singleRideMoosalpregion: {
          Basket: {
            modalContent:
              '<b>Erwachsene</b>: Jahrgang 1999 und älter <br>' +
              '<b>Jugendliche</b>: Jahrgänge 2000 bis 2004 <br>' +
              '<b>Kinder</b>: Jahrgänge 2005 bis 2011 <br>' +
              '<b>Kleinkinder</b>: Jahrgang 2012 und jünger <br>',
          },
        },
      },
    },
    niesen: {
      componentLevel: {
        StandardCalendar: {
          headerText: 'Wählen Sie ein Reisedatum',
          modalTitle: 'Wählen Sie ein Reisedatum',
          modalContent:
            'Klicken Sie im Kalender auf das gewünschtes Reisedatum. Eine Bergbahnfahrt ist einen Tag gültig.',
        },
        HotelCalendar: {
          headerText: 'Wählen Sie Ihr Anreisedatum',
          modalTitle: 'Wählen Sie ein Anreisedatum',
          modalContent: 'Wählen Sie im Kalender das gewünschte Anreisedatum.',
        },
      },
    },
    // destination independent fallback
    destinationFallback: {
      Basket: {
        modalTitle: 'Tarifunterscheidungen',
      },
      StandardCalendar: {
        headerText: 'Wählen Sie Ihr Datum',
      },
      HotelRoomSelector: {
        headerText: 'Wählen Sie den gewünschten Zimmertyp',
      },
      ContactForm: {
        headerText: 'Gruppenanfrage',
        modalContent: 'Gruppenanfrage',
        modalTitle: 'Gruppenanfrage',
      },
      SendRequest: {
        headerText: 'Anfrage abschicken',
      },
      SelectMedium: {
        headerText: 'Personalisierung',
      },
      SeatReservation: {
        modalTitle:
          'Was ist eine Bahnfahrt-Reservation und was gilt es zu beachten?',
      },
      SeasonAbos: {
        headerText: 'Informationen zu den Abonnementen',
        modalTitle: 'Informationen zu den Abonnementen',
      },
      ShopLogin: {
        headerText: 'Anmelden',
      },
    },
  },
  powerBi: {
    couldNotBeLoaded: 'Power BIs konnten nicht abgerufen werden.',
    couldNotBeSaved: 'Power BI konnte nicht gespeichwert werden.',
    couldNotBeDeleted: 'Power BI konnte nicht gelöscht werden.',
    urlMustNotBeEmpty: 'Die URL darf nicht leer sein.',
    selectBi: 'Wählen Sie Ihr Power BI aus',
  },
  stornoHistory: {
    excelDownload: 'Liste Exportieren',
    cancellations: 'Stornierungen',
    voucher: 'Online Guthaben',
    exportCancellations: 'Export Stornierungen',
    exportVoucher: 'Export Online Guthaben',
    customer: 'Kunde',
    cancellationId: 'Stornierungs Id',
    customerId: 'Kunden Id',
    customerFirstName: 'Vorname Kunde',
    customerLastName: 'Nachname Kunde',
    customerMail: 'E-Mail Kunde',
    productName: 'Produkt',
    employeeFirstName: 'Vorname Mitarbeiter',
    employeeLastName: 'Nachname Mitarbeiter',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    priceNet: 'Nettopreis',
    priceGross: 'Bruttopreis',
    mail: 'Mail',
    reason: 'Begründung',
    address: 'Adresse',
    zip: 'PLZ',
    city: 'Stadt',
    currency: 'Währung',
    balance: 'Onlineguthaben',
    noData: 'Keine Daten im gewählten Zeitraum',
  },
  ticketProvider: {
    swisspass: 'Swisspass',
    novatouch: 'Novatouch',
    axess: 'Axess',
    skidata: 'Skidata',
    unknown: 'Unbekannt',
  },
  basketConditions: {
    unknownBasketCondition: 'Unbekannte Warenkorb-Bedingung',
    basketConditionsNotMet:
      'Bitte beachten Sie die Bedingungen bei Ihrem gewählten Produkt.',
    textComposition: {
      min: 'mind. {count}x',
      max: 'max. {count}x',
      but: 'jedoch',
      conditionText:
        'Fügen Sie "{attributeTitle}" {conditionTexts} dem Warenkorb hinzu.',
    },
  },
}
